(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json-js-ir'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json-js-ir'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json-js-ir'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json-js-ir'.");
    }
    root['kotlinx-serialization-kotlinx-serialization-json-js-ir'] = factory(typeof this['kotlinx-serialization-kotlinx-serialization-json-js-ir'] === 'undefined' ? {} : this['kotlinx-serialization-kotlinx-serialization-json-js-ir'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib']);
  }
}(globalThis, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var EmptySerializersModule = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var protoOf = kotlin_kotlin.$_$.hb;
  var initMetadataForObject = kotlin_kotlin.$_$.ma;
  var VOID = kotlin_kotlin.$_$.g;
  var Unit_instance = kotlin_kotlin.$_$.d5;
  var StringFormat = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i2;
  var initMetadataForClass = kotlin_kotlin.$_$.ha;
  var toString = kotlin_kotlin.$_$.lb;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.q1;
  var charSequenceLength = kotlin_kotlin.$_$.v9;
  var charSequenceGet = kotlin_kotlin.$_$.u9;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.m2;
  var equals = kotlin_kotlin.$_$.z9;
  var toString_0 = kotlin_kotlin.$_$.pf;
  var Decoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l1;
  var CompositeDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j1;
  var initMetadataForInterface = kotlin_kotlin.$_$.ka;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ia;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.d1;
  var THROW_CCE = kotlin_kotlin.$_$.oe;
  var hashCode = kotlin_kotlin.$_$.ga;
  var joinToString = kotlin_kotlin.$_$.i7;
  var KtMap = kotlin_kotlin.$_$.o5;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.jf;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var getKClassFromExpression = kotlin_kotlin.$_$.e;
  var getBooleanHashCode = kotlin_kotlin.$_$.ca;
  var getStringHashCode = kotlin_kotlin.$_$.fa;
  var KtList = kotlin_kotlin.$_$.m5;
  var toInt = kotlin_kotlin.$_$.md;
  var toLong = kotlin_kotlin.$_$.od;
  var toDouble = kotlin_kotlin.$_$.kd;
  var toLongOrNull = kotlin_kotlin.$_$.nd;
  var toDoubleOrNull = kotlin_kotlin.$_$.jd;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.r4;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s;
  var InlinePrimitiveDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var SEALED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
  var buildSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f1;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var MapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var SerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d1;
  var ListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var ENUM_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z;
  var toULongOrNull = kotlin_kotlin.$_$.sd;
  var ULong = kotlin_kotlin.$_$.ve;
  var Companion_getInstance = kotlin_kotlin.$_$.b5;
  var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.s3;
  var isInterface = kotlin_kotlin.$_$.va;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.u1;
  var lazy_0 = kotlin_kotlin.$_$.kf;
  var get_isNullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c1;
  var get_isInline = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
  var get_annotations = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a1;
  var KProperty1 = kotlin_kotlin.$_$.zb;
  var getPropertyCallableRef = kotlin_kotlin.$_$.ea;
  var Encoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m1;
  var CompositeEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k1;
  var toLong_0 = kotlin_kotlin.$_$.jb;
  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.i3;
  var UInt__toString_impl_dbgl21 = kotlin_kotlin.$_$.k3;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.r3;
  var ULong__toString_impl_f9au7k = kotlin_kotlin.$_$.t3;
  var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.z2;
  var UByte__toString_impl_v72jg = kotlin_kotlin.$_$.b3;
  var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.a4;
  var UShort__toString_impl_edaoee = kotlin_kotlin.$_$.c4;
  var ElementMarker = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p1;
  var captureStack = kotlin_kotlin.$_$.r9;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h2;
  var SerializationException_init_$Init$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a;
  var charSequenceSubSequence = kotlin_kotlin.$_$.w9;
  var coerceAtLeast = kotlin_kotlin.$_$.ob;
  var coerceAtMost = kotlin_kotlin.$_$.qb;
  var SerializationException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b;
  var CLASS_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.u;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.l;
  var singleOrNull = kotlin_kotlin.$_$.e8;
  var emptyMap = kotlin_kotlin.$_$.t6;
  var getValue = kotlin_kotlin.$_$.d7;
  var fillArrayVal = kotlin_kotlin.$_$.ba;
  var copyOf = kotlin_kotlin.$_$.m6;
  var copyOf_0 = kotlin_kotlin.$_$.n6;
  var LIST_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i;
  var DeepRecursiveFunction = kotlin_kotlin.$_$.ce;
  var invoke = kotlin_kotlin.$_$.ff;
  var CoroutineImpl = kotlin_kotlin.$_$.j9;
  var DeepRecursiveScope = kotlin_kotlin.$_$.de;
  var Unit = kotlin_kotlin.$_$.ye;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.v8;
  var initMetadataForLambda = kotlin_kotlin.$_$.la;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.ja;
  var AbstractPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n1;
  var getKClass = kotlin_kotlin.$_$.f;
  var DeserializationStrategy = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d2;
  var SealedClassSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g2;
  var jsonCachedSerialNames = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x1;
  var ENUM = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e1;
  var PrimitiveKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y;
  var PolymorphicKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x;
  var CONTEXTUAL_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f;
  var MAP_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j;
  var contextual = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a2;
  var SerializersModuleCollector = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var AbstractDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h1;
  var ensureNotNull = kotlin_kotlin.$_$.ef;
  var contains = kotlin_kotlin.$_$.cc;
  var plus = kotlin_kotlin.$_$.mf;
  var MissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f2;
  var IllegalArgumentException = kotlin_kotlin.$_$.he;
  var isFinite = kotlin_kotlin.$_$.hf;
  var isFinite_0 = kotlin_kotlin.$_$.gf;
  var toUInt = kotlin_kotlin.$_$.rd;
  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.j3;
  var toULong = kotlin_kotlin.$_$.td;
  var toUByte = kotlin_kotlin.$_$.qd;
  var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.a3;
  var toUShort = kotlin_kotlin.$_$.ud;
  var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.b4;
  var objectCreate = kotlin_kotlin.$_$.gb;
  var AbstractEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i1;
  var findPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j2;
  var toString_1 = kotlin_kotlin.$_$.t2;
  var Companion_getInstance_0 = kotlin_kotlin.$_$.a5;
  var serializer_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u;
  var Companion_getInstance_1 = kotlin_kotlin.$_$.z4;
  var serializer_2 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var Companion_getInstance_2 = kotlin_kotlin.$_$.c5;
  var serializer_3 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var setOf = kotlin_kotlin.$_$.d8;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.s2;
  var numberToChar = kotlin_kotlin.$_$.db;
  var equals_0 = kotlin_kotlin.$_$.hc;
  var NamedValueDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
  var IllegalArgumentException_init_$Create$_0 = kotlin_kotlin.$_$.o1;
  var toByte = kotlin_kotlin.$_$.ib;
  var toShort = kotlin_kotlin.$_$.kb;
  var single = kotlin_kotlin.$_$.bd;
  var Char = kotlin_kotlin.$_$.ae;
  var emptySet = kotlin_kotlin.$_$.u6;
  var plus_0 = kotlin_kotlin.$_$.u7;
  var toList = kotlin_kotlin.$_$.l8;
  var Enum = kotlin_kotlin.$_$.ee;
  var getContextualDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g1;
  var last = kotlin_kotlin.$_$.o7;
  var removeLast = kotlin_kotlin.$_$.a8;
  var lastIndexOf = kotlin_kotlin.$_$.uc;
  var Long = kotlin_kotlin.$_$.je;
  var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.o2;
  var charArray = kotlin_kotlin.$_$.t9;
  var indexOf = kotlin_kotlin.$_$.lc;
  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.c1;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.n;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(Json, 'Json', VOID, VOID, [StringFormat]);
  initMetadataForObject(Default, 'Default', VOID, Json);
  initMetadataForClass(JsonBuilder, 'JsonBuilder');
  initMetadataForClass(JsonImpl, 'JsonImpl', VOID, Json);
  initMetadataForClass(JsonClassDiscriminator, 'JsonClassDiscriminator');
  initMetadataForClass(JsonNames, 'JsonNames');
  initMetadataForClass(JsonConfiguration, 'JsonConfiguration');
  initMetadataForInterface(JsonDecoder, 'JsonDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  initMetadataForCompanion(Companion);
  initMetadataForClass(JsonElement, 'JsonElement', VOID, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(JsonObject, 'JsonObject', VOID, JsonElement, [JsonElement, KtMap], VOID, VOID, {0: JsonObjectSerializer_getInstance});
  initMetadataForClass(JsonPrimitive, 'JsonPrimitive', VOID, JsonElement, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
  initMetadataForObject(JsonNull, 'JsonNull', VOID, JsonPrimitive, [JsonPrimitive, SerializerFactory], VOID, VOID, {0: JsonNull_getInstance});
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(JsonLiteral, 'JsonLiteral', VOID, JsonPrimitive);
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(JsonArray, 'JsonArray', VOID, JsonElement, [JsonElement, KtList], VOID, VOID, {0: JsonArraySerializer_getInstance});
  initMetadataForObject(JsonElementSerializer, 'JsonElementSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonObjectDescriptor, 'JsonObjectDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForObject(JsonObjectSerializer, 'JsonObjectSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonArrayDescriptor, 'JsonArrayDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForObject(JsonArraySerializer, 'JsonArraySerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonNullSerializer, 'JsonNullSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonLiteralSerializer, 'JsonLiteralSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(defer$1, VOID, VOID, VOID, [SerialDescriptor]);
  initMetadataForInterface(JsonEncoder, 'JsonEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
  initMetadataForClass(Composer, 'Composer');
  initMetadataForClass(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers', VOID, Composer);
  initMetadataForClass(ComposerForUnquotedLiterals, 'ComposerForUnquotedLiterals', VOID, Composer);
  initMetadataForClass(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint', VOID, Composer);
  initMetadataForClass(JsonElementMarker, 'JsonElementMarker');
  initMetadataForClass(JsonException, 'JsonException', VOID, SerializationException);
  initMetadataForClass(JsonEncodingException, 'JsonEncodingException', VOID, JsonException);
  initMetadataForClass(JsonDecodingException, 'JsonDecodingException', VOID, JsonException);
  initMetadataForObject(Tombstone, 'Tombstone');
  initMetadataForClass(JsonPath, 'JsonPath', JsonPath);
  initMetadataForLambda(JsonTreeReader$readDeepRecursive$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($readObjectCOROUTINE$0, CoroutineImpl);
  initMetadataForClass(JsonTreeReader, 'JsonTreeReader', VOID, VOID, VOID, [0]);
  initMetadataForClass(PolymorphismValidator, 'PolymorphismValidator', VOID, VOID, [SerializersModuleCollector]);
  initMetadataForClass(Key, 'Key', Key);
  initMetadataForClass(DescriptorSchemaCache, 'DescriptorSchemaCache', DescriptorSchemaCache);
  initMetadataForClass(DiscriminatorHolder, 'DiscriminatorHolder');
  initMetadataForClass(StreamingJsonDecoder, 'StreamingJsonDecoder', VOID, AbstractDecoder, [JsonDecoder, AbstractDecoder]);
  initMetadataForClass(JsonDecoderForUnsignedTypes, 'JsonDecoderForUnsignedTypes', VOID, AbstractDecoder);
  initMetadataForClass(StreamingJsonEncoder, 'StreamingJsonEncoder', VOID, AbstractEncoder, [JsonEncoder, AbstractEncoder]);
  initMetadataForClass(AbstractJsonTreeDecoder, 'AbstractJsonTreeDecoder', VOID, NamedValueDecoder, [NamedValueDecoder, JsonDecoder]);
  initMetadataForClass(JsonTreeDecoder, 'JsonTreeDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonTreeListDecoder, 'JsonTreeListDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonPrimitiveDecoder, 'JsonPrimitiveDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonTreeMapDecoder, 'JsonTreeMapDecoder', VOID, JsonTreeDecoder);
  initMetadataForClass(WriteMode, 'WriteMode', VOID, Enum);
  initMetadataForClass(AbstractJsonLexer, 'AbstractJsonLexer');
  initMetadataForObject(CharMappings, 'CharMappings');
  initMetadataForClass(StringJsonLexer, 'StringJsonLexer', VOID, AbstractJsonLexer);
  initMetadataForClass(JsonToStringWriter, 'JsonToStringWriter', JsonToStringWriter);
  //endregion
  function Default() {
    Default_instance = this;
    Json.call(this, new JsonConfiguration(), EmptySerializersModule());
  }
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Json(configuration, serializersModule) {
    Default_getInstance();
    this.p57_1 = configuration;
    this.q57_1 = serializersModule;
    this.r57_1 = new DescriptorSchemaCache();
  }
  protoOf(Json).o1e = function () {
    return this.q57_1;
  };
  protoOf(Json).m1e = function (serializer, value) {
    var result = new JsonToStringWriter();
    try {
      encodeByWriter(this, result, serializer, value);
      return result.toString();
    }finally {
      result.a2p();
    }
  };
  protoOf(Json).n1e = function (deserializer, string) {
    var lexer = new StringJsonLexer(string);
    var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.t1d(), null);
    var result = input.w1g(deserializer);
    lexer.f58();
    return result;
  };
  function Json_0(from, builderAction) {
    from = from === VOID ? Default_getInstance() : from;
    var builder = new JsonBuilder(from);
    builderAction(builder);
    var conf = builder.u58();
    return new JsonImpl(conf, builder.t58_1);
  }
  function JsonBuilder(json) {
    this.g58_1 = json.p57_1.v58_1;
    this.h58_1 = json.p57_1.a59_1;
    this.i58_1 = json.p57_1.w58_1;
    this.j58_1 = json.p57_1.x58_1;
    this.k58_1 = json.p57_1.y58_1;
    this.l58_1 = json.p57_1.z58_1;
    this.m58_1 = json.p57_1.b59_1;
    this.n58_1 = json.p57_1.c59_1;
    this.o58_1 = json.p57_1.d59_1;
    this.p58_1 = json.p57_1.e59_1;
    this.q58_1 = json.p57_1.f59_1;
    this.r58_1 = json.p57_1.g59_1;
    this.s58_1 = json.p57_1.h59_1;
    this.t58_1 = json.o1e();
  }
  protoOf(JsonBuilder).u58 = function () {
    if (this.o58_1) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this.p58_1 === 'type')) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message = 'Class discriminator should not be specified when array polymorphism is specified';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
    }
    if (!this.l58_1) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this.m58_1 === '    ')) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_0 = 'Indent should not be specified when default printing mode is used';
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
    } else if (!(this.m58_1 === '    ')) {
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.text.all' call
        var indexedObject = this.m58_1;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(indexedObject)) {
          var element = charSequenceGet(indexedObject, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
          if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
            tmp$ret$3 = false;
            break $l$block;
          }
        }
        tmp$ret$3 = true;
      }
      var allWhitespaces = tmp$ret$3;
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!allWhitespaces) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_1 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.m58_1;
        throw IllegalArgumentException_init_$Create$(toString(message_1));
      }
    }
    return new JsonConfiguration(this.g58_1, this.i58_1, this.j58_1, this.k58_1, this.l58_1, this.h58_1, this.m58_1, this.n58_1, this.o58_1, this.p58_1, this.q58_1, this.r58_1, this.s58_1);
  };
  function validateConfiguration($this) {
    if (equals($this.o1e(), EmptySerializersModule()))
      return Unit_instance;
    var collector = new PolymorphismValidator($this.p57_1.d59_1, $this.p57_1.e59_1);
    $this.o1e().c1x(collector);
  }
  function JsonImpl(configuration, module_0) {
    Json.call(this, configuration, module_0);
    validateConfiguration(this);
  }
  function JsonClassDiscriminator() {
  }
  function JsonNames() {
  }
  function JsonConfiguration(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy) {
    encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
    ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
    isLenient = isLenient === VOID ? false : isLenient;
    allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
    prettyPrint = prettyPrint === VOID ? false : prettyPrint;
    explicitNulls = explicitNulls === VOID ? true : explicitNulls;
    prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
    coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
    useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
    classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
    allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
    useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
    namingStrategy = namingStrategy === VOID ? null : namingStrategy;
    this.v58_1 = encodeDefaults;
    this.w58_1 = ignoreUnknownKeys;
    this.x58_1 = isLenient;
    this.y58_1 = allowStructuredMapKeys;
    this.z58_1 = prettyPrint;
    this.a59_1 = explicitNulls;
    this.b59_1 = prettyPrintIndent;
    this.c59_1 = coerceInputValues;
    this.d59_1 = useArrayPolymorphism;
    this.e59_1 = classDiscriminator;
    this.f59_1 = allowSpecialFloatingPointValues;
    this.g59_1 = useAlternativeNames;
    this.h59_1 = namingStrategy;
  }
  protoOf(JsonConfiguration).toString = function () {
    return 'JsonConfiguration(encodeDefaults=' + this.v58_1 + ', ignoreUnknownKeys=' + this.w58_1 + ', isLenient=' + this.x58_1 + ', ' + ('allowStructuredMapKeys=' + this.y58_1 + ', prettyPrint=' + this.z58_1 + ', explicitNulls=' + this.a59_1 + ', ') + ("prettyPrintIndent='" + this.b59_1 + "', coerceInputValues=" + this.c59_1 + ', useArrayPolymorphism=' + this.d59_1 + ', ') + ("classDiscriminator='" + this.e59_1 + "', allowSpecialFloatingPointValues=" + this.f59_1 + ', useAlternativeNames=' + this.g59_1 + ', ') + ('namingStrategy=' + toString_0(this.h59_1) + ')');
  };
  function JsonDecoder() {
  }
  function get_jsonUnquotedLiteralDescriptor() {
    _init_properties_JsonElement_kt__7cbdc2();
    return jsonUnquotedLiteralDescriptor;
  }
  var jsonUnquotedLiteralDescriptor;
  function Companion() {
  }
  var Companion_instance;
  function Companion_getInstance_3() {
    return Companion_instance;
  }
  function JsonElement() {
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_4() {
    return Companion_instance_0;
  }
  function JsonObject$toString$lambda(_name_for_destructuring_parameter_0__wldtmu) {
    // Inline function 'kotlin.collections.component1' call
    var k = _name_for_destructuring_parameter_0__wldtmu.u();
    // Inline function 'kotlin.collections.component2' call
    var v = _name_for_destructuring_parameter_0__wldtmu.v();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.JsonObject.toString.<anonymous>.<anonymous>' call
    printQuoted(this_0, k);
    this_0.p7(_Char___init__impl__6a9atx(58));
    this_0.n7(v);
    return this_0.toString();
  }
  function JsonObject(content) {
    JsonElement.call(this);
    this.k59_1 = content;
  }
  protoOf(JsonObject).t = function () {
    return this.k59_1.t();
  };
  protoOf(JsonObject).z1 = function () {
    return this.k59_1.z1();
  };
  protoOf(JsonObject).j = function () {
    return this.k59_1.j();
  };
  protoOf(JsonObject).a2 = function () {
    return this.k59_1.a2();
  };
  protoOf(JsonObject).v2i = function (key) {
    return this.k59_1.w1(key);
  };
  protoOf(JsonObject).w1 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.v2i((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject).w2i = function (key) {
    return this.k59_1.y1(key);
  };
  protoOf(JsonObject).y1 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.w2i((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject).o = function () {
    return this.k59_1.o();
  };
  protoOf(JsonObject).equals = function (other) {
    return equals(this.k59_1, other);
  };
  protoOf(JsonObject).hashCode = function () {
    return hashCode(this.k59_1);
  };
  protoOf(JsonObject).toString = function () {
    var tmp = this.k59_1.t();
    return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
  };
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.m59_1.v();
  }
  function JsonNull$_anonymous__enib48() {
    return JsonNullSerializer_getInstance();
  }
  function JsonNull() {
    JsonNull_instance = this;
    JsonPrimitive.call(this);
    this.l59_1 = 'null';
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m59_1 = lazy(tmp_0, JsonNull$_anonymous__enib48);
  }
  protoOf(JsonNull).k3w = function () {
    return this.l59_1;
  };
  protoOf(JsonNull).n59 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(JsonNull).k1p = function (typeParamsSerializers) {
    return this.n59();
  };
  var JsonNull_instance;
  function JsonNull_getInstance() {
    if (JsonNull_instance == null)
      new JsonNull();
    return JsonNull_instance;
  }
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_5() {
    return Companion_instance_1;
  }
  function JsonPrimitive() {
    JsonElement.call(this);
  }
  protoOf(JsonPrimitive).toString = function () {
    return this.k3w();
  };
  function JsonPrimitive_0(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, true);
  }
  function JsonLiteral(body, isString, coerceToInlineType) {
    coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
    JsonPrimitive.call(this);
    this.o59_1 = isString;
    this.p59_1 = coerceToInlineType;
    this.q59_1 = toString(body);
    if (!(this.p59_1 == null)) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!this.p59_1.d1f()) {
        // Inline function 'kotlin.require.<anonymous>' call
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
    }
  }
  protoOf(JsonLiteral).k3w = function () {
    return this.q59_1;
  };
  protoOf(JsonLiteral).toString = function () {
    var tmp;
    if (this.o59_1) {
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.JsonLiteral.toString.<anonymous>' call
      printQuoted(this_0, this.q59_1);
      tmp = this_0.toString();
    } else {
      tmp = this.q59_1;
    }
    return tmp;
  };
  protoOf(JsonLiteral).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof JsonLiteral))
      THROW_CCE();
    if (!(this.o59_1 === other.o59_1))
      return false;
    if (!(this.q59_1 === other.q59_1))
      return false;
    return true;
  };
  protoOf(JsonLiteral).hashCode = function () {
    var result = getBooleanHashCode(this.o59_1);
    result = imul(31, result) + getStringHashCode(this.q59_1) | 0;
    return result;
  };
  function Companion_2() {
  }
  var Companion_instance_2;
  function Companion_getInstance_6() {
    return Companion_instance_2;
  }
  function JsonArray(content) {
    JsonElement.call(this);
    this.r59_1 = content;
  }
  protoOf(JsonArray).j = function () {
    return this.r59_1.j();
  };
  protoOf(JsonArray).s59 = function (element) {
    return this.r59_1.r(element);
  };
  protoOf(JsonArray).r = function (element) {
    if (!(element instanceof JsonElement))
      return false;
    return this.s59(element instanceof JsonElement ? element : THROW_CCE());
  };
  protoOf(JsonArray).t59 = function (elements) {
    return this.r59_1.r1(elements);
  };
  protoOf(JsonArray).r1 = function (elements) {
    return this.t59(elements);
  };
  protoOf(JsonArray).p = function (index) {
    return this.r59_1.p(index);
  };
  protoOf(JsonArray).u59 = function (element) {
    return this.r59_1.s(element);
  };
  protoOf(JsonArray).s = function (element) {
    if (!(element instanceof JsonElement))
      return -1;
    return this.u59(element instanceof JsonElement ? element : THROW_CCE());
  };
  protoOf(JsonArray).o = function () {
    return this.r59_1.o();
  };
  protoOf(JsonArray).g = function () {
    return this.r59_1.g();
  };
  protoOf(JsonArray).q = function (index) {
    return this.r59_1.q(index);
  };
  protoOf(JsonArray).equals = function (other) {
    return equals(this.r59_1, other);
  };
  protoOf(JsonArray).hashCode = function () {
    return hashCode(this.r59_1);
  };
  protoOf(JsonArray).toString = function () {
    return joinToString(this.r59_1, ',', '[', ']');
  };
  function get_booleanOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toBooleanStrictOrNull(_this__u8e3s4.k3w());
  }
  function get_int(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toInt(_this__u8e3s4.k3w());
  }
  function get_long(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toLong(_this__u8e3s4.k3w());
  }
  function get_float(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    // Inline function 'kotlin.text.toFloat' call
    var this_0 = _this__u8e3s4.k3w();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return toDouble(this_0);
  }
  function get_double(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toDouble(_this__u8e3s4.k3w());
  }
  function get_contentOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp;
    if (_this__u8e3s4 instanceof JsonNull) {
      tmp = null;
    } else {
      tmp = _this__u8e3s4.k3w();
    }
    return tmp;
  }
  function get_longOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toLongOrNull(_this__u8e3s4.k3w());
  }
  function get_doubleOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toDoubleOrNull(_this__u8e3s4.k3w());
  }
  function get_jsonPrimitive(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      error(_this__u8e3s4, 'JsonPrimitive');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function error(_this__u8e3s4, element) {
    _init_properties_JsonElement_kt__7cbdc2();
    throw IllegalArgumentException_init_$Create$('Element ' + toString(getKClassFromExpression(_this__u8e3s4)) + ' is not a ' + element);
  }
  var properties_initialized_JsonElement_kt_abxy8s;
  function _init_properties_JsonElement_kt__7cbdc2() {
    if (!properties_initialized_JsonElement_kt_abxy8s) {
      properties_initialized_JsonElement_kt_abxy8s = true;
      jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_instance));
    }
  }
  function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.e1e('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
    $this$buildSerialDescriptor.e1e('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
    $this$buildSerialDescriptor.e1e('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
    $this$buildSerialDescriptor.e1e('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
    $this$buildSerialDescriptor.e1e('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
    return Unit_instance;
  }
  function JsonElementSerializer$descriptor$lambda$lambda() {
    return JsonPrimitiveSerializer_getInstance().v59_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_0() {
    return JsonNullSerializer_getInstance().w59_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_1() {
    return JsonLiteralSerializer_getInstance().x59_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_2() {
    return JsonObjectSerializer_getInstance().y59_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_3() {
    return JsonArraySerializer_getInstance().z59_1;
  }
  function JsonElementSerializer() {
    JsonElementSerializer_instance = this;
    var tmp = this;
    var tmp_0 = SEALED_getInstance();
    tmp.a5a_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
  }
  protoOf(JsonElementSerializer).t1d = function () {
    return this.a5a_1;
  };
  protoOf(JsonElementSerializer).b5a = function (encoder, value) {
    verify(encoder);
    if (value instanceof JsonPrimitive) {
      encoder.o1i(JsonPrimitiveSerializer_getInstance(), value);
    } else {
      if (value instanceof JsonObject) {
        encoder.o1i(JsonObjectSerializer_getInstance(), value);
      } else {
        if (value instanceof JsonArray) {
          encoder.o1i(JsonArraySerializer_getInstance(), value);
        }
      }
    }
  };
  protoOf(JsonElementSerializer).u1d = function (encoder, value) {
    return this.b5a(encoder, value instanceof JsonElement ? value : THROW_CCE());
  };
  protoOf(JsonElementSerializer).v1d = function (decoder) {
    var input = asJsonDecoder(decoder);
    return input.j59();
  };
  var JsonElementSerializer_instance;
  function JsonElementSerializer_getInstance() {
    if (JsonElementSerializer_instance == null)
      new JsonElementSerializer();
    return JsonElementSerializer_instance;
  }
  function JsonObjectDescriptor() {
    JsonObjectDescriptor_instance = this;
    this.c5a_1 = MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).t1d();
    this.d5a_1 = 'kotlinx.serialization.json.JsonObject';
  }
  protoOf(JsonObjectDescriptor).b1f = function () {
    return this.c5a_1.b1f();
  };
  protoOf(JsonObjectDescriptor).c1f = function () {
    return this.c5a_1.c1f();
  };
  protoOf(JsonObjectDescriptor).d1f = function () {
    return this.c5a_1.d1f();
  };
  protoOf(JsonObjectDescriptor).w1e = function () {
    return this.c5a_1.w1e();
  };
  protoOf(JsonObjectDescriptor).e1f = function () {
    return this.c5a_1.e1f();
  };
  protoOf(JsonObjectDescriptor).f1f = function (index) {
    return this.c5a_1.f1f(index);
  };
  protoOf(JsonObjectDescriptor).g1f = function (index) {
    return this.c5a_1.g1f(index);
  };
  protoOf(JsonObjectDescriptor).h1f = function (name) {
    return this.c5a_1.h1f(name);
  };
  protoOf(JsonObjectDescriptor).i1f = function (index) {
    return this.c5a_1.i1f(index);
  };
  protoOf(JsonObjectDescriptor).j1f = function (index) {
    return this.c5a_1.j1f(index);
  };
  protoOf(JsonObjectDescriptor).a1f = function () {
    return this.d5a_1;
  };
  var JsonObjectDescriptor_instance;
  function JsonObjectDescriptor_getInstance() {
    if (JsonObjectDescriptor_instance == null)
      new JsonObjectDescriptor();
    return JsonObjectDescriptor_instance;
  }
  function JsonObjectSerializer() {
    JsonObjectSerializer_instance = this;
    this.y59_1 = JsonObjectDescriptor_getInstance();
  }
  protoOf(JsonObjectSerializer).t1d = function () {
    return this.y59_1;
  };
  protoOf(JsonObjectSerializer).e5a = function (encoder, value) {
    verify(encoder);
    MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).u1d(encoder, value);
  };
  protoOf(JsonObjectSerializer).u1d = function (encoder, value) {
    return this.e5a(encoder, value instanceof JsonObject ? value : THROW_CCE());
  };
  protoOf(JsonObjectSerializer).v1d = function (decoder) {
    verify_0(decoder);
    return new JsonObject(MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).v1d(decoder));
  };
  var JsonObjectSerializer_instance;
  function JsonObjectSerializer_getInstance() {
    if (JsonObjectSerializer_instance == null)
      new JsonObjectSerializer();
    return JsonObjectSerializer_instance;
  }
  function JsonArrayDescriptor() {
    JsonArrayDescriptor_instance = this;
    this.f5a_1 = ListSerializer(JsonElementSerializer_getInstance()).t1d();
    this.g5a_1 = 'kotlinx.serialization.json.JsonArray';
  }
  protoOf(JsonArrayDescriptor).b1f = function () {
    return this.f5a_1.b1f();
  };
  protoOf(JsonArrayDescriptor).c1f = function () {
    return this.f5a_1.c1f();
  };
  protoOf(JsonArrayDescriptor).d1f = function () {
    return this.f5a_1.d1f();
  };
  protoOf(JsonArrayDescriptor).w1e = function () {
    return this.f5a_1.w1e();
  };
  protoOf(JsonArrayDescriptor).e1f = function () {
    return this.f5a_1.e1f();
  };
  protoOf(JsonArrayDescriptor).f1f = function (index) {
    return this.f5a_1.f1f(index);
  };
  protoOf(JsonArrayDescriptor).g1f = function (index) {
    return this.f5a_1.g1f(index);
  };
  protoOf(JsonArrayDescriptor).h1f = function (name) {
    return this.f5a_1.h1f(name);
  };
  protoOf(JsonArrayDescriptor).i1f = function (index) {
    return this.f5a_1.i1f(index);
  };
  protoOf(JsonArrayDescriptor).j1f = function (index) {
    return this.f5a_1.j1f(index);
  };
  protoOf(JsonArrayDescriptor).a1f = function () {
    return this.g5a_1;
  };
  var JsonArrayDescriptor_instance;
  function JsonArrayDescriptor_getInstance() {
    if (JsonArrayDescriptor_instance == null)
      new JsonArrayDescriptor();
    return JsonArrayDescriptor_instance;
  }
  function JsonArraySerializer() {
    JsonArraySerializer_instance = this;
    this.z59_1 = JsonArrayDescriptor_getInstance();
  }
  protoOf(JsonArraySerializer).t1d = function () {
    return this.z59_1;
  };
  protoOf(JsonArraySerializer).h5a = function (encoder, value) {
    verify(encoder);
    ListSerializer(JsonElementSerializer_getInstance()).u1d(encoder, value);
  };
  protoOf(JsonArraySerializer).u1d = function (encoder, value) {
    return this.h5a(encoder, value instanceof JsonArray ? value : THROW_CCE());
  };
  protoOf(JsonArraySerializer).v1d = function (decoder) {
    verify_0(decoder);
    return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).v1d(decoder));
  };
  var JsonArraySerializer_instance;
  function JsonArraySerializer_getInstance() {
    if (JsonArraySerializer_instance == null)
      new JsonArraySerializer();
    return JsonArraySerializer_instance;
  }
  function defer(deferred) {
    return new defer$1(deferred);
  }
  function JsonPrimitiveSerializer() {
    JsonPrimitiveSerializer_instance = this;
    this.v59_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
  }
  protoOf(JsonPrimitiveSerializer).t1d = function () {
    return this.v59_1;
  };
  protoOf(JsonPrimitiveSerializer).i5a = function (encoder, value) {
    verify(encoder);
    var tmp;
    if (value instanceof JsonNull) {
      encoder.o1i(JsonNullSerializer_getInstance(), JsonNull_getInstance());
      tmp = Unit_instance;
    } else {
      var tmp_0 = JsonLiteralSerializer_getInstance();
      encoder.o1i(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(JsonPrimitiveSerializer).u1d = function (encoder, value) {
    return this.i5a(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
  };
  protoOf(JsonPrimitiveSerializer).v1d = function (decoder) {
    var result = asJsonDecoder(decoder).j59();
    if (!(result instanceof JsonPrimitive))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonPrimitive, had ' + toString(getKClassFromExpression(result)), toString(result));
    return result;
  };
  var JsonPrimitiveSerializer_instance;
  function JsonPrimitiveSerializer_getInstance() {
    if (JsonPrimitiveSerializer_instance == null)
      new JsonPrimitiveSerializer();
    return JsonPrimitiveSerializer_instance;
  }
  function JsonNullSerializer() {
    JsonNullSerializer_instance = this;
    this.w59_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
  }
  protoOf(JsonNullSerializer).t1d = function () {
    return this.w59_1;
  };
  protoOf(JsonNullSerializer).j5a = function (encoder, value) {
    verify(encoder);
    encoder.r1h();
  };
  protoOf(JsonNullSerializer).u1d = function (encoder, value) {
    return this.j5a(encoder, value instanceof JsonNull ? value : THROW_CCE());
  };
  protoOf(JsonNullSerializer).v1d = function (decoder) {
    verify_0(decoder);
    if (decoder.i1g()) {
      throw new JsonDecodingException("Expected 'null' literal");
    }
    decoder.j1g();
    return JsonNull_getInstance();
  };
  var JsonNullSerializer_instance;
  function JsonNullSerializer_getInstance() {
    if (JsonNullSerializer_instance == null)
      new JsonNullSerializer();
    return JsonNullSerializer_instance;
  }
  function JsonLiteralSerializer() {
    JsonLiteralSerializer_instance = this;
    this.x59_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
  }
  protoOf(JsonLiteralSerializer).t1d = function () {
    return this.x59_1;
  };
  protoOf(JsonLiteralSerializer).k5a = function (encoder, value) {
    verify(encoder);
    if (value.o59_1) {
      return encoder.a1i(value.q59_1);
    }
    if (!(value.p59_1 == null)) {
      return encoder.c1i(value.p59_1).a1i(value.q59_1);
    }
    var tmp0_safe_receiver = get_longOrNull(value);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.w1h(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = toULongOrNull(value.q59_1);
    var tmp = tmp1_safe_receiver;
    if ((tmp == null ? null : new ULong(tmp)) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_0 = tmp1_safe_receiver;
      // Inline function 'kotlin.contracts.contract' call
      var it = (tmp_0 == null ? null : new ULong(tmp_0)).ii_1;
      var tmp_1 = encoder.c1i(serializer_0(Companion_getInstance()).t1d());
      // Inline function 'kotlin.ULong.toLong' call
      var tmp$ret$1 = _ULong___get_data__impl__fggpzb(it);
      tmp_1.w1h(tmp$ret$1);
      return Unit_instance;
    }
    var tmp2_safe_receiver = get_doubleOrNull(value);
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.y1h(tmp2_safe_receiver);
    }
    var tmp3_safe_receiver = get_booleanOrNull(value);
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.s1h(tmp3_safe_receiver);
    }
    encoder.a1i(value.q59_1);
  };
  protoOf(JsonLiteralSerializer).u1d = function (encoder, value) {
    return this.k5a(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
  };
  protoOf(JsonLiteralSerializer).v1d = function (decoder) {
    var result = asJsonDecoder(decoder).j59();
    if (!(result instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonLiteral, had ' + toString(getKClassFromExpression(result)), toString(result));
    return result;
  };
  var JsonLiteralSerializer_instance;
  function JsonLiteralSerializer_getInstance() {
    if (JsonLiteralSerializer_instance == null)
      new JsonLiteralSerializer();
    return JsonLiteralSerializer_instance;
  }
  function verify(encoder) {
    asJsonEncoder(encoder);
  }
  function asJsonDecoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function verify_0(decoder) {
    asJsonDecoder(decoder);
  }
  function asJsonEncoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _get_original__l7ku1m($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.l5a_1;
    original$factory();
    return this_0.v();
  }
  function defer$1($deferred) {
    this.l5a_1 = lazy_0($deferred);
  }
  protoOf(defer$1).a1f = function () {
    return _get_original__l7ku1m(this).a1f();
  };
  protoOf(defer$1).e1f = function () {
    return _get_original__l7ku1m(this).e1f();
  };
  protoOf(defer$1).c1f = function () {
    return _get_original__l7ku1m(this).c1f();
  };
  protoOf(defer$1).i1f = function (index) {
    return _get_original__l7ku1m(this).i1f(index);
  };
  protoOf(defer$1).h1f = function (name) {
    return _get_original__l7ku1m(this).h1f(name);
  };
  protoOf(defer$1).f1f = function (index) {
    return _get_original__l7ku1m(this).f1f(index);
  };
  protoOf(defer$1).g1f = function (index) {
    return _get_original__l7ku1m(this).g1f(index);
  };
  protoOf(defer$1).j1f = function (index) {
    return _get_original__l7ku1m(this).j1f(index);
  };
  function original$factory() {
    return getPropertyCallableRef('original', 1, KProperty1, function (receiver) {
      return _get_original__l7ku1m(receiver);
    }, null);
  }
  function JsonEncoder() {
  }
  function Composer(writer) {
    this.m5a_1 = writer;
    this.n5a_1 = true;
  }
  protoOf(Composer).o5a = function () {
    this.n5a_1 = true;
  };
  protoOf(Composer).p5a = function () {
    return Unit_instance;
  };
  protoOf(Composer).q5a = function () {
    this.n5a_1 = false;
  };
  protoOf(Composer).r5a = function () {
    return Unit_instance;
  };
  protoOf(Composer).s5a = function (v) {
    return this.m5a_1.t5a(v);
  };
  protoOf(Composer).u5a = function (v) {
    return this.m5a_1.v5a(v);
  };
  protoOf(Composer).w5a = function (v) {
    return this.m5a_1.v5a(v.toString());
  };
  protoOf(Composer).x5a = function (v) {
    return this.m5a_1.v5a(v.toString());
  };
  protoOf(Composer).y5a = function (v) {
    return this.m5a_1.z5a(toLong_0(v));
  };
  protoOf(Composer).a5b = function (v) {
    return this.m5a_1.z5a(toLong_0(v));
  };
  protoOf(Composer).b5b = function (v) {
    return this.m5a_1.z5a(toLong_0(v));
  };
  protoOf(Composer).c5b = function (v) {
    return this.m5a_1.z5a(v);
  };
  protoOf(Composer).d5b = function (v) {
    return this.m5a_1.v5a(v.toString());
  };
  protoOf(Composer).e5b = function (value) {
    return this.m5a_1.f5b(value);
  };
  function Composer_0(sb, json) {
    return json.p57_1.z58_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
  }
  function ComposerForUnsignedNumbers(writer, forceQuoting) {
    Composer.call(this, writer);
    this.i5b_1 = forceQuoting;
  }
  protoOf(ComposerForUnsignedNumbers).b5b = function (v) {
    if (this.i5b_1) {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
      this.e5b(UInt__toString_impl_dbgl21(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
      this.u5a(UInt__toString_impl_dbgl21(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).c5b = function (v) {
    if (this.i5b_1) {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
      this.e5b(ULong__toString_impl_f9au7k(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
      this.u5a(ULong__toString_impl_f9au7k(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).y5a = function (v) {
    if (this.i5b_1) {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
      this.e5b(UByte__toString_impl_v72jg(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
      this.u5a(UByte__toString_impl_v72jg(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).a5b = function (v) {
    if (this.i5b_1) {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$0 = _UShort___init__impl__jigrne(v);
      this.e5b(UShort__toString_impl_edaoee(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$1 = _UShort___init__impl__jigrne(v);
      this.u5a(UShort__toString_impl_edaoee(tmp$ret$1));
    }
  };
  function ComposerForUnquotedLiterals(writer, forceQuoting) {
    Composer.call(this, writer);
    this.l5b_1 = forceQuoting;
  }
  protoOf(ComposerForUnquotedLiterals).e5b = function (value) {
    if (this.l5b_1) {
      protoOf(Composer).e5b.call(this, value);
    } else {
      protoOf(Composer).u5a.call(this, value);
    }
  };
  function ComposerWithPrettyPrint(writer, json) {
    Composer.call(this, writer);
    this.o5b_1 = json;
    this.p5b_1 = 0;
  }
  protoOf(ComposerWithPrettyPrint).o5a = function () {
    this.n5a_1 = true;
    this.p5b_1 = this.p5b_1 + 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).p5a = function () {
    this.p5b_1 = this.p5b_1 - 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).q5a = function () {
    this.n5a_1 = false;
    this.u5a('\n');
    // Inline function 'kotlin.repeat' call
    var times = this.p5b_1;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.ComposerWithPrettyPrint.nextItem.<anonymous>' call
        this.u5a(this.o5b_1.p57_1.b59_1);
      }
       while (inductionVariable < times);
  };
  protoOf(ComposerWithPrettyPrint).r5a = function () {
    this.s5a(_Char___init__impl__6a9atx(32));
  };
  function readIfAbsent($this, descriptor, index) {
    $this.r5b_1 = (!descriptor.j1f(index) && descriptor.g1f(index).w1e());
    return $this.r5b_1;
  }
  function JsonElementMarker$readIfAbsent$ref($boundThis) {
    var l = function (p0, p1) {
      return readIfAbsent($boundThis, p0, p1);
    };
    l.callableName = 'readIfAbsent';
    return l;
  }
  function JsonElementMarker(descriptor) {
    var tmp = this;
    tmp.q5b_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
    this.r5b_1 = false;
  }
  protoOf(JsonElementMarker).s5b = function (index) {
    this.q5b_1.a1n(index);
  };
  protoOf(JsonElementMarker).t5b = function () {
    return this.q5b_1.b1n();
  };
  function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
    _this__u8e3s4.u5b('Unexpected special floating-point value ' + toString(result) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification', VOID, "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'");
  }
  function JsonEncodingException(message) {
    JsonException.call(this, message);
    captureStack(this, JsonEncodingException);
  }
  function InvalidKeyKindException(keyDescriptor) {
    return new JsonEncodingException("Value of type '" + keyDescriptor.a1f() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.e1f().toString() + "'.\n") + "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
  }
  function JsonDecodingException(message) {
    JsonException.call(this, message);
    captureStack(this, JsonDecodingException);
  }
  function JsonDecodingException_0(offset, message, input) {
    return JsonDecodingException_1(offset, message + '\nJSON input: ' + toString(minify(input, offset)));
  }
  function InvalidFloatingPointDecoded(value, key, output) {
    return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
  }
  function JsonDecodingException_1(offset, message) {
    return new JsonDecodingException(offset >= 0 ? 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
  }
  function UnknownKeyException(key, input) {
    return JsonDecodingException_1(-1, "Encountered an unknown key '" + key + "'.\n" + "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.\n" + ('Current input: ' + toString(minify(input))));
  }
  function InvalidFloatingPointEncoded(value, output) {
    return new JsonEncodingException('Unexpected special floating-point value ' + toString(value) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output))));
  }
  function JsonException(message) {
    SerializationException_init_$Init$(message, this);
    captureStack(this, JsonException);
  }
  function unexpectedFpErrorMessage(value, key, output) {
    return 'Unexpected special floating-point value ' + toString(value) + ' with key ' + key + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output)));
  }
  function minify(_this__u8e3s4, offset) {
    offset = offset === VOID ? -1 : offset;
    if (charSequenceLength(_this__u8e3s4) < 200)
      return _this__u8e3s4;
    if (offset === -1) {
      var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
      if (start <= 0)
        return _this__u8e3s4;
      // Inline function 'kotlin.text.substring' call
      var endIndex = charSequenceLength(_this__u8e3s4);
      return '.....' + toString(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
    }
    var start_0 = offset - 30 | 0;
    var end = offset + 30 | 0;
    var prefix = start_0 <= 0 ? '' : '.....';
    var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
    // Inline function 'kotlin.text.substring' call
    var startIndex = coerceAtLeast(start_0, 0);
    var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
    return prefix + toString(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex_0)) + suffix;
  }
  function get_JsonDeserializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonDeserializationNamesKey;
  }
  var JsonDeserializationNamesKey;
  function get_JsonSerializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonSerializationNamesKey;
  }
  var JsonSerializationNamesKey;
  function getJsonNameIndex(_this__u8e3s4, json, name) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var strategy = namingStrategy(_this__u8e3s4, json);
    if (!(strategy == null))
      return getJsonNameIndex$getJsonNameIndexSlowPath(json, _this__u8e3s4, name);
    var index = _this__u8e3s4.h1f(name);
    if (!(index === -3))
      return index;
    if (!json.p57_1.g59_1)
      return index;
    return getJsonNameIndex$getJsonNameIndexSlowPath(json, _this__u8e3s4, name);
  }
  function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
    suffix = suffix === VOID ? '' : suffix;
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var index = getJsonNameIndex(_this__u8e3s4, json, name);
    if (index === -3)
      throw SerializationException_init_$Create$(_this__u8e3s4.a1f() + " does not contain element with name '" + name + "'" + suffix);
    return index;
  }
  function getJsonElementName(_this__u8e3s4, json, index) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var strategy = namingStrategy(_this__u8e3s4, json);
    return strategy == null ? _this__u8e3s4.i1f(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
  }
  function namingStrategy(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return equals(_this__u8e3s4.e1f(), CLASS_getInstance()) ? json.p57_1.h59_1 : null;
  }
  function deserializationNamesMap(_this__u8e3s4, descriptor) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(_this__u8e3s4);
    var tmp_0 = get_JsonDeserializationNamesKey();
    return tmp.w5b(descriptor, tmp_0, deserializationNamesMap$lambda(descriptor, _this__u8e3s4));
  }
  function serializationNamesIndices(_this__u8e3s4, json, strategy) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(json);
    var tmp_0 = get_JsonSerializationNamesKey();
    return tmp.w5b(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
  }
  function buildDeserializationNamesMap(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var builder = LinkedHashMap_init_$Create$();
    var strategy = namingStrategy(_this__u8e3s4, json);
    var inductionVariable = 0;
    var last = _this__u8e3s4.c1f();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.filterIsInstance' call
        // Inline function 'kotlin.collections.filterIsInstanceTo' call
        var this_0 = _this__u8e3s4.f1f(i);
        var destination = ArrayList_init_$Create$();
        var tmp0_iterator = this_0.g();
        while (tmp0_iterator.h()) {
          var element = tmp0_iterator.i();
          if (element instanceof JsonNames) {
            destination.e(element);
          }
        }
        var tmp1_safe_receiver = singleOrNull(destination);
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.x5b_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var inductionVariable_0 = 0;
          var last_0 = tmp2_safe_receiver.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = tmp2_safe_receiver[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
            buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, element_0, i);
          }
        }
        if (strategy == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, strategy.y5b(_this__u8e3s4, i, _this__u8e3s4.i1f(i)), i);
        }
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.collections.ifEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (builder.o()) {
      // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
      tmp = emptyMap();
    } else {
      tmp = builder;
    }
    return tmp;
  }
  function getJsonNameIndex$getJsonNameIndexSlowPath($json, $this_getJsonNameIndex, $name) {
    var tmp0_elvis_lhs = deserializationNamesMap($json, $this_getJsonNameIndex).y1($name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  }
  function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    if ((isInterface(_this__u8e3s4, KtMap) ? _this__u8e3s4 : THROW_CCE()).w1(name)) {
      throw new JsonException("The suggested name '" + name + "' for property " + $this_buildDeserializationNamesMap.i1f(index) + ' is already one of the names for property ' + ($this_buildDeserializationNamesMap.i1f(getValue(_this__u8e3s4, name)) + ' in ' + toString($this_buildDeserializationNamesMap)));
    }
    // Inline function 'kotlin.collections.set' call
    _this__u8e3s4.b2(name, index);
  }
  function deserializationNamesMap$lambda($descriptor, $this_deserializationNamesMap) {
    return function () {
      return buildDeserializationNamesMap($descriptor, $this_deserializationNamesMap);
    };
  }
  function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
    return function () {
      var tmp = 0;
      var tmp_0 = $this_serializationNamesIndices.c1f();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        var baseName = $this_serializationNamesIndices.i1f(tmp_2);
        tmp_1[tmp_2] = $strategy.y5b($this_serializationNamesIndices, tmp_2, baseName);
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  var properties_initialized_JsonNamesMap_kt_ljpf42;
  function _init_properties_JsonNamesMap_kt__cbbp0k() {
    if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
      properties_initialized_JsonNamesMap_kt_ljpf42 = true;
      JsonDeserializationNamesKey = new Key();
      JsonSerializationNamesKey = new Key();
    }
  }
  function Tombstone() {
  }
  var Tombstone_instance;
  function Tombstone_getInstance() {
    return Tombstone_instance;
  }
  function resize($this) {
    var newSize = imul($this.b5c_1, 2);
    $this.z5b_1 = copyOf($this.z5b_1, newSize);
    $this.a5c_1 = copyOf_0($this.a5c_1, newSize);
  }
  function JsonPath() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.z5b_1 = fillArrayVal(Array(8), null);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(8);
    while (tmp_1 < 8) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.a5c_1 = tmp_2;
    this.b5c_1 = -1;
  }
  protoOf(JsonPath).c5c = function (sd) {
    this.b5c_1 = this.b5c_1 + 1 | 0;
    var depth = this.b5c_1;
    if (depth === this.z5b_1.length) {
      resize(this);
    }
    this.z5b_1[depth] = sd;
  };
  protoOf(JsonPath).d5c = function (index) {
    this.a5c_1[this.b5c_1] = index;
  };
  protoOf(JsonPath).e5c = function (key) {
    var tmp;
    if (!(this.a5c_1[this.b5c_1] === -2)) {
      this.b5c_1 = this.b5c_1 + 1 | 0;
      tmp = this.b5c_1 === this.z5b_1.length;
    } else {
      tmp = false;
    }
    if (tmp) {
      resize(this);
    }
    this.z5b_1[this.b5c_1] = key;
    this.a5c_1[this.b5c_1] = -2;
  };
  protoOf(JsonPath).f5c = function () {
    if (this.a5c_1[this.b5c_1] === -2) {
      this.z5b_1[this.b5c_1] = Tombstone_instance;
    }
  };
  protoOf(JsonPath).g5c = function () {
    var depth = this.b5c_1;
    if (this.a5c_1[depth] === -2) {
      this.a5c_1[depth] = -1;
      this.b5c_1 = this.b5c_1 - 1 | 0;
    }
    if (!(this.b5c_1 === -1)) {
      this.b5c_1 = this.b5c_1 - 1 | 0;
    }
  };
  protoOf(JsonPath).h5c = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>' call
    this_0.o7('$');
    // Inline function 'kotlin.repeat' call
    var times = this.b5c_1 + 1 | 0;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>.<anonymous>' call
        var element = this.z5b_1[index];
        if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
          if (equals(element.e1f(), LIST_getInstance())) {
            if (!(this.a5c_1[index] === -1)) {
              this_0.o7('[');
              this_0.n7(this.a5c_1[index]);
              this_0.o7(']');
            }
          } else {
            var idx = this.a5c_1[index];
            if (idx >= 0) {
              this_0.o7('.');
              this_0.o7(element.i1f(idx));
            }
          }
        } else {
          if (!(element === Tombstone_instance)) {
            this_0.o7('[');
            this_0.o7("'");
            this_0.n7(element);
            this_0.o7("'");
            this_0.o7(']');
          }
        }
      }
       while (inductionVariable < times);
    return this_0.toString();
  };
  protoOf(JsonPath).toString = function () {
    return this.h5c();
  };
  function encodeByWriter(_this__u8e3s4, writer, serializer, value) {
    var tmp = WriteMode_OBJ_getInstance();
    // Inline function 'kotlin.arrayOfNulls' call
    var size = values().length;
    var tmp$ret$0 = fillArrayVal(Array(size), null);
    var encoder = StreamingJsonEncoder_init_$Create$(writer, _this__u8e3s4, tmp, tmp$ret$0);
    encoder.o1i(serializer, value);
  }
  function readObject($this) {
    // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
    var lastToken = $this.q5c_1.t5c(6);
    if ($this.q5c_1.u5c() === 4) {
      $this.q5c_1.u5b('Unexpected leading comma');
    }
    // Inline function 'kotlin.collections.linkedMapOf' call
    var result = LinkedHashMap_init_$Create$();
    $l$loop: while ($this.q5c_1.v5c()) {
      var key = $this.r5c_1 ? $this.q5c_1.x5c() : $this.q5c_1.w5c();
      $this.q5c_1.t5c(5);
      // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObject.<anonymous>' call
      var element = $this.y5c();
      // Inline function 'kotlin.collections.set' call
      result.b2(key, element);
      lastToken = $this.q5c_1.z5c();
      var tmp0_subject = lastToken;
      if (tmp0_subject !== 4)
        if (tmp0_subject === 7)
          break $l$loop;
        else {
          $this.q5c_1.u5b('Expected end of the object or comma');
        }
    }
    if (lastToken === 6) {
      $this.q5c_1.t5c(7);
    } else if (lastToken === 4) {
      $this.q5c_1.u5b('Unexpected trailing comma');
    }
    return new JsonObject(result);
  }
  function readObject_0(_this__u8e3s4, $this, $completion) {
    var tmp = new $readObjectCOROUTINE$0($this, _this__u8e3s4, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  }
  function readArray($this) {
    var lastToken = $this.q5c_1.z5c();
    if ($this.q5c_1.u5c() === 4) {
      $this.q5c_1.u5b('Unexpected leading comma');
    }
    // Inline function 'kotlin.collections.arrayListOf' call
    var result = ArrayList_init_$Create$();
    while ($this.q5c_1.v5c()) {
      var element = $this.y5c();
      result.e(element);
      lastToken = $this.q5c_1.z5c();
      if (!(lastToken === 4)) {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var this_0 = $this.q5c_1;
        var condition = lastToken === 9;
        var position = this_0.b58_1;
        if (!condition) {
          // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readArray.<anonymous>' call
          var tmp$ret$1 = 'Expected end of the array or comma';
          this_0.u5b(tmp$ret$1, position);
        }
      }
    }
    if (lastToken === 8) {
      $this.q5c_1.t5c(9);
    } else if (lastToken === 4) {
      $this.q5c_1.u5b('Unexpected trailing comma');
    }
    return new JsonArray(result);
  }
  function readValue($this, isString) {
    var tmp;
    if ($this.r5c_1 || !isString) {
      tmp = $this.q5c_1.x5c();
    } else {
      tmp = $this.q5c_1.w5c();
    }
    var string = tmp;
    if (!isString && string === 'null')
      return JsonNull_getInstance();
    return new JsonLiteral(string, isString);
  }
  function readDeepRecursive($this) {
    return invoke(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda_0($this, null)), Unit_instance);
  }
  function JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation) {
    this.w5d_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsonTreeReader$readDeepRecursive$slambda).b5e = function ($this$$receiver, it, $completion) {
    var tmp = this.c5e($this$$receiver, it, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof DeepRecursiveScope ? p1 : THROW_CCE();
    return this.b5e(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            this.z5d_1 = this.w5d_1.q5c_1.u5c();
            if (this.z5d_1 === 1) {
              this.a5e_1 = readValue(this.w5d_1, true);
              this.j8_1 = 2;
              continue $sm;
            } else {
              if (this.z5d_1 === 0) {
                this.a5e_1 = readValue(this.w5d_1, false);
                this.j8_1 = 2;
                continue $sm;
              } else {
                if (this.z5d_1 === 6) {
                  this.j8_1 = 1;
                  suspendResult = readObject_0(this.x5d_1, this.w5d_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (this.z5d_1 === 8) {
                    this.a5e_1 = readArray(this.w5d_1);
                    this.j8_1 = 2;
                    continue $sm;
                  } else {
                    var tmp_0 = this;
                    this.w5d_1.q5c_1.u5b("Can't begin reading element, unexpected token");
                  }
                }
              }
            }

            break;
          case 1:
            this.a5e_1 = suspendResult;
            this.j8_1 = 2;
            continue $sm;
          case 2:
            return this.a5e_1;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).c5e = function ($this$$receiver, it, completion) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this.w5d_1, completion);
    i.x5d_1 = $this$$receiver;
    i.y5d_1 = it;
    return i;
  };
  function JsonTreeReader$readDeepRecursive$slambda_0(this$0, resultContinuation) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation);
    var l = function ($this$$receiver, it, $completion) {
      return i.b5e($this$$receiver, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $readObjectCOROUTINE$0(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i5d_1 = _this__u8e3s4;
    this.j5d_1 = _this__u8e3s4_0;
  }
  protoOf($readObjectCOROUTINE$0).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 5;
            var tmp_0 = this;
            tmp_0.k5d_1 = this.i5d_1;
            this.l5d_1 = this.k5d_1.q5c_1.t5c(6);
            if (this.k5d_1.q5c_1.u5c() === 4) {
              this.k5d_1.q5c_1.u5b('Unexpected leading comma');
            }

            var tmp_1 = this;
            tmp_1.m5d_1 = LinkedHashMap_init_$Create$();
            this.j8_1 = 1;
            continue $sm;
          case 1:
            if (!this.k5d_1.q5c_1.v5c()) {
              this.j8_1 = 4;
              continue $sm;
            }

            this.n5d_1 = this.k5d_1.r5c_1 ? this.k5d_1.q5c_1.x5c() : this.k5d_1.q5c_1.w5c();
            this.k5d_1.q5c_1.t5c(5);
            this.j8_1 = 2;
            suspendResult = this.j5d_1.pg(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var element = suspendResult;
            var this_0 = this.m5d_1;
            var key = this.n5d_1;
            this_0.b2(key, element);
            this.l5d_1 = this.k5d_1.q5c_1.z5c();
            var tmp0_subject = this.l5d_1;
            if (tmp0_subject === 4) {
              this.j8_1 = 3;
              continue $sm;
            } else {
              if (tmp0_subject === 7) {
                this.j8_1 = 4;
                continue $sm;
              } else {
                this.k5d_1.q5c_1.u5b('Expected end of the object or comma');
              }
            }

            break;
          case 3:
            this.j8_1 = 1;
            continue $sm;
          case 4:
            if (this.l5d_1 === 6) {
              this.k5d_1.q5c_1.t5c(7);
            } else if (this.l5d_1 === 4) {
              this.k5d_1.q5c_1.u5b('Unexpected trailing comma');
            }

            return new JsonObject(this.m5d_1);
          case 5:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 5) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function JsonTreeReader(configuration, lexer) {
    this.q5c_1 = lexer;
    this.r5c_1 = configuration.x58_1;
    this.s5c_1 = 0;
  }
  protoOf(JsonTreeReader).y5c = function () {
    var token = this.q5c_1.u5c();
    var tmp;
    if (token === 1) {
      tmp = readValue(this, true);
    } else if (token === 0) {
      tmp = readValue(this, false);
    } else if (token === 6) {
      var tmp_0;
      this.s5c_1 = this.s5c_1 + 1 | 0;
      if (this.s5c_1 === 200) {
        tmp_0 = readDeepRecursive(this);
      } else {
        tmp_0 = readObject(this);
      }
      var result = tmp_0;
      this.s5c_1 = this.s5c_1 - 1 | 0;
      tmp = result;
    } else if (token === 8) {
      tmp = readArray(this);
    } else {
      this.q5c_1.u5b('Cannot begin reading element, unexpected token: ' + token);
    }
    return tmp;
  };
  function classDiscriminator(_this__u8e3s4, json) {
    var tmp0_iterator = _this__u8e3s4.b1f().g();
    while (tmp0_iterator.h()) {
      var annotation = tmp0_iterator.i();
      if (annotation instanceof JsonClassDiscriminator)
        return annotation.d5e_1;
    }
    return json.p57_1.e59_1;
  }
  function decodeSerializableValuePolymorphic(_this__u8e3s4, deserializer) {
    var tmp;
    if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
      tmp = true;
    } else {
      tmp = _this__u8e3s4.i59().p57_1.d59_1;
    }
    if (tmp) {
      return deserializer.v1d(_this__u8e3s4);
    }
    var discriminator = classDiscriminator(deserializer.t1d(), _this__u8e3s4.i59());
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = _this__u8e3s4.j59();
    var descriptor = deserializer.t1d();
    if (!(value instanceof JsonObject)) {
      throw JsonDecodingException_1(-1, 'Expected ' + toString(getKClass(JsonObject)) + ' as the serialized body of ' + descriptor.a1f() + ', but had ' + toString(getKClassFromExpression(value)));
    }
    var jsonTree = value;
    var tmp0_safe_receiver = jsonTree.w2i(discriminator);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
    var type = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.k3w();
    var tmp2_elvis_lhs = deserializer.k1e(_this__u8e3s4, type);
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      throwSerializerNotFound(type, jsonTree);
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var actualSerializer = tmp_0;
    var tmp_1 = _this__u8e3s4.i59();
    return readPolymorphicJson(tmp_1, discriminator, jsonTree, isInterface(actualSerializer, DeserializationStrategy) ? actualSerializer : THROW_CCE());
  }
  function throwSerializerNotFound(type, jsonTree) {
    var suffix = type == null ? "missing class discriminator ('null')" : "class discriminator '" + type + "'";
    throw JsonDecodingException_0(-1, 'Polymorphic serializer was not found for ' + suffix, jsonTree.toString());
  }
  function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
    if (!(serializer instanceof SealedClassSerializer))
      return Unit_instance;
    if (jsonCachedSerialNames(actualSerializer.t1d()).r(classDiscriminator)) {
      var baseName = serializer.t1d().a1f();
      var actualName = actualSerializer.t1d().a1f();
      // Inline function 'kotlin.error' call
      var message = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation or fall back to array polymorphism';
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  function checkKind(kind) {
    if (kind instanceof ENUM) {
      // Inline function 'kotlin.error' call
      var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (kind instanceof PrimitiveKind) {
      // Inline function 'kotlin.error' call
      var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    if (kind instanceof PolymorphicKind) {
      // Inline function 'kotlin.error' call
      var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
      throw IllegalStateException_init_$Create$(toString(message_1));
    }
  }
  function validateIfSealed$accessor$1ad0flx(serializer, actualSerializer, classDiscriminator) {
    return validateIfSealed(serializer, actualSerializer, classDiscriminator);
  }
  function checkKind_0($this, descriptor, actualClass) {
    var kind = descriptor.e1f();
    var tmp;
    if (kind instanceof PolymorphicKind) {
      tmp = true;
    } else {
      tmp = equals(kind, CONTEXTUAL_getInstance());
    }
    if (tmp) {
      throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.p9() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind.toString() + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
    }
    if ($this.e5e_1)
      return Unit_instance;
    var tmp_0;
    var tmp_1;
    if (equals(kind, LIST_getInstance()) || equals(kind, MAP_getInstance())) {
      tmp_1 = true;
    } else {
      tmp_1 = kind instanceof PrimitiveKind;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = kind instanceof ENUM;
    }
    if (tmp_0) {
      throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.p9() + ' of kind ' + kind.toString() + ' cannot be serialized polymorphically with class discriminator.');
    }
  }
  function checkDiscriminatorCollisions($this, descriptor, actualClass) {
    var inductionVariable = 0;
    var last = descriptor.c1f();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var name = descriptor.i1f(i);
        if (name === $this.f5e_1) {
          throw IllegalArgumentException_init_$Create$('Polymorphic serializer for ' + toString(actualClass) + " has property '" + name + "' that conflicts " + 'with JSON class discriminator. You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation ' + 'or fall back to array polymorphism');
        }
      }
       while (inductionVariable < last);
  }
  function PolymorphismValidator(useArrayPolymorphism, discriminator) {
    this.e5e_1 = useArrayPolymorphism;
    this.f5e_1 = discriminator;
  }
  protoOf(PolymorphismValidator).k1x = function (kClass, provider) {
  };
  protoOf(PolymorphismValidator).n1x = function (baseClass, actualClass, actualSerializer) {
    var descriptor = actualSerializer.t1d();
    checkKind_0(this, descriptor, actualClass);
    if (!this.e5e_1) {
      checkDiscriminatorCollisions(this, descriptor, actualClass);
    }
  };
  protoOf(PolymorphismValidator).o1x = function (baseClass, defaultSerializerProvider) {
  };
  protoOf(PolymorphismValidator).p1x = function (baseClass, defaultDeserializerProvider) {
  };
  function Key() {
  }
  function DescriptorSchemaCache() {
    this.v5b_1 = createMapForCache(16);
  }
  protoOf(DescriptorSchemaCache).g5e = function (descriptor, key, value) {
    // Inline function 'kotlin.collections.set' call
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.v5b_1;
    var value_0 = this_0.y1(descriptor);
    var tmp;
    if (value_0 == null) {
      // Inline function 'kotlinx.serialization.json.internal.DescriptorSchemaCache.set.<anonymous>' call
      var answer = createMapForCache(2);
      this_0.b2(descriptor, answer);
      tmp = answer;
    } else {
      tmp = value_0;
    }
    var this_1 = tmp;
    var key_0 = key instanceof Key ? key : THROW_CCE();
    var value_1 = !(value == null) ? value : THROW_CCE();
    this_1.b2(key_0, value_1);
  };
  protoOf(DescriptorSchemaCache).w5b = function (descriptor, key, defaultValue) {
    var tmp0_safe_receiver = this.h5e(descriptor, key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp0_safe_receiver;
    }
    var value = defaultValue();
    this.g5e(descriptor, key, value);
    return value;
  };
  protoOf(DescriptorSchemaCache).h5e = function (descriptor, key) {
    var tmp0_safe_receiver = this.v5b_1.y1(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.y1(key instanceof Key ? key : THROW_CCE());
    }
    var tmp_0 = tmp;
    return !(tmp_0 == null) ? tmp_0 : null;
  };
  function DiscriminatorHolder(discriminatorToSkip) {
    this.i5e_1 = discriminatorToSkip;
  }
  function trySkip(_this__u8e3s4, $this, unknownKey) {
    if (_this__u8e3s4 == null)
      return false;
    if (_this__u8e3s4.i5e_1 === unknownKey) {
      _this__u8e3s4.i5e_1 = null;
      return true;
    }
    return false;
  }
  function skipLeftoverElements($this, descriptor) {
    while (!($this.n1h(descriptor) === -1)) {
    }
  }
  function checkLeadingComma($this) {
    if ($this.v57_1.u5c() === 4) {
      $this.v57_1.u5b('Unexpected leading comma');
    }
  }
  function decodeMapIndex($this) {
    var hasComma = false;
    var decodingKey = !(($this.x57_1 % 2 | 0) === 0);
    if (decodingKey) {
      if (!($this.x57_1 === -1)) {
        hasComma = $this.v57_1.k5e();
      }
    } else {
      $this.v57_1.j5e(_Char___init__impl__6a9atx(58));
    }
    var tmp;
    if ($this.v57_1.v5c()) {
      if (decodingKey) {
        if ($this.x57_1 === -1) {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var this_0 = $this.v57_1;
          var condition = !hasComma;
          var position = this_0.b58_1;
          if (!condition) {
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
            var tmp$ret$0 = 'Unexpected trailing comma';
            this_0.u5b(tmp$ret$0, position);
          }
        } else {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var this_1 = $this.v57_1;
          var condition_0 = hasComma;
          var position_0 = this_1.b58_1;
          if (!condition_0) {
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
            var tmp$ret$1 = 'Expected comma after the key-value pair';
            this_1.u5b(tmp$ret$1, position_0);
          }
        }
      }
      $this.x57_1 = $this.x57_1 + 1 | 0;
      tmp = $this.x57_1;
    } else {
      if (hasComma) {
        $this.v57_1.u5b("Expected '}', but had ',' instead");
      }
      tmp = -1;
    }
    return tmp;
  }
  function coerceInputValue($this, descriptor, index) {
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var this_0 = $this.t57_1;
      var elementDescriptor = descriptor.g1f(index);
      var tmp;
      if (!elementDescriptor.w1e()) {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
        tmp = $this.v57_1.l5e(true);
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$1 = true;
        break $l$block_2;
      }
      if (equals(elementDescriptor.e1f(), ENUM_getInstance())) {
        var tmp_0;
        if (elementDescriptor.w1e()) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
          tmp_0 = $this.v57_1.l5e(false);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$1 = false;
          break $l$block_2;
        }
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
        var tmp0_elvis_lhs = $this.v57_1.m5e($this.z57_1.x58_1);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$1 = false;
          break $l$block_2;
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_1;
        var enumIndex = getJsonNameIndex(elementDescriptor, this_0, enumValue);
        if (enumIndex === -3) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
          $this.v57_1.w5c();
          tmp$ret$1 = true;
          break $l$block_2;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function decodeObjectIndex($this, descriptor) {
    var hasComma = $this.v57_1.k5e();
    while ($this.v57_1.v5c()) {
      hasComma = false;
      var key = decodeStringKey($this);
      $this.v57_1.j5e(_Char___init__impl__6a9atx(58));
      var index = getJsonNameIndex(descriptor, $this.t57_1, key);
      var tmp;
      if (!(index === -3)) {
        var tmp_0;
        if ($this.z57_1.c59_1 && coerceInputValue($this, descriptor, index)) {
          hasComma = $this.v57_1.k5e();
          tmp_0 = false;
        } else {
          var tmp0_safe_receiver = $this.a58_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.s5b(index);
          }
          return index;
        }
        tmp = tmp_0;
      } else {
        tmp = true;
      }
      var isUnknown = tmp;
      if (isUnknown) {
        hasComma = handleUnknown($this, key);
      }
    }
    if (hasComma) {
      $this.v57_1.u5b('Unexpected trailing comma');
    }
    var tmp1_safe_receiver = $this.a58_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.t5b();
    return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
  }
  function handleUnknown($this, key) {
    if ($this.z57_1.w58_1 || trySkip($this.y57_1, $this, key)) {
      $this.v57_1.o5e($this.z57_1.x58_1);
    } else {
      $this.v57_1.n5e(key);
    }
    return $this.v57_1.k5e();
  }
  function decodeListIndex($this) {
    var hasComma = $this.v57_1.k5e();
    var tmp;
    if ($this.v57_1.v5c()) {
      if (!($this.x57_1 === -1) && !hasComma) {
        $this.v57_1.u5b('Expected end of the array or comma');
      }
      $this.x57_1 = $this.x57_1 + 1 | 0;
      tmp = $this.x57_1;
    } else {
      if (hasComma) {
        $this.v57_1.u5b('Unexpected trailing comma');
      }
      tmp = -1;
    }
    return tmp;
  }
  function decodeStringKey($this) {
    var tmp;
    if ($this.z57_1.x58_1) {
      tmp = $this.v57_1.q5e();
    } else {
      tmp = $this.v57_1.p5e();
    }
    return tmp;
  }
  function StreamingJsonDecoder(json, mode, lexer, descriptor, discriminatorHolder) {
    AbstractDecoder.call(this);
    this.t57_1 = json;
    this.u57_1 = mode;
    this.v57_1 = lexer;
    this.w57_1 = this.t57_1.o1e();
    this.x57_1 = -1;
    this.y57_1 = discriminatorHolder;
    this.z57_1 = this.t57_1.p57_1;
    this.a58_1 = this.z57_1.a59_1 ? null : new JsonElementMarker(descriptor);
  }
  protoOf(StreamingJsonDecoder).i59 = function () {
    return this.t57_1;
  };
  protoOf(StreamingJsonDecoder).o1e = function () {
    return this.w57_1;
  };
  protoOf(StreamingJsonDecoder).j59 = function () {
    return (new JsonTreeReader(this.t57_1.p57_1, this.v57_1)).y5c();
  };
  protoOf(StreamingJsonDecoder).w1g = function (deserializer) {
    try {
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.t57_1.p57_1.d59_1;
      }
      if (tmp) {
        return deserializer.v1d(this);
      }
      var discriminator = classDiscriminator(deserializer.t1d(), this.t57_1);
      var type = this.v57_1.r5e(discriminator, this.z57_1.x58_1);
      var actualSerializer = null;
      if (!(type == null)) {
        actualSerializer = deserializer.k1e(this, type);
      }
      if (actualSerializer == null) {
        return decodeSerializableValuePolymorphic(this, isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE());
      }
      this.y57_1 = new DiscriminatorHolder(discriminator);
      var tmp_0 = actualSerializer.v1d(this);
      var result = !(tmp_0 == null) ? tmp_0 : THROW_CCE();
      return result;
    } catch ($p) {
      if ($p instanceof MissingFieldException) {
        var e = $p;
        if (contains(ensureNotNull(e.message), 'at path'))
          throw e;
        throw new MissingFieldException(e.r1e_1, plus(e.message, ' at path: ') + this.v57_1.c58_1.h5c(), e);
      } else {
        throw $p;
      }
    }
  };
  protoOf(StreamingJsonDecoder).x1g = function (descriptor) {
    var newMode = switchMode(this.t57_1, descriptor);
    this.v57_1.c58_1.c5c(descriptor);
    this.v57_1.j5e(newMode.u5e_1);
    checkLeadingComma(this);
    var tmp;
    switch (newMode.f2_1) {
      case 1:
      case 2:
      case 3:
        tmp = new StreamingJsonDecoder(this.t57_1, newMode, this.v57_1, descriptor, this.y57_1);
        break;
      default:
        var tmp_0;
        if (this.u57_1.equals(newMode) && this.t57_1.p57_1.a59_1) {
          tmp_0 = this;
        } else {
          tmp_0 = new StreamingJsonDecoder(this.t57_1, newMode, this.v57_1, descriptor, this.y57_1);
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).y1g = function (descriptor) {
    if (this.t57_1.p57_1.w58_1 && descriptor.c1f() === 0) {
      skipLeftoverElements(this, descriptor);
    }
    this.v57_1.j5e(this.u57_1.v5e_1);
    this.v57_1.c58_1.g5c();
  };
  protoOf(StreamingJsonDecoder).i1g = function () {
    var tmp;
    var tmp0_safe_receiver = this.a58_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r5b_1;
    if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
      tmp = !this.v57_1.w5e();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).j1g = function () {
    return null;
  };
  protoOf(StreamingJsonDecoder).j1h = function (descriptor, index, deserializer, previousValue) {
    var isMapKey = this.u57_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
    if (isMapKey) {
      this.v57_1.c58_1.f5c();
    }
    var value = protoOf(AbstractDecoder).j1h.call(this, descriptor, index, deserializer, previousValue);
    if (isMapKey) {
      this.v57_1.c58_1.e5c(value);
    }
    return value;
  };
  protoOf(StreamingJsonDecoder).n1h = function (descriptor) {
    var index;
    switch (this.u57_1.f2_1) {
      case 0:
        index = decodeObjectIndex(this, descriptor);
        break;
      case 2:
        index = decodeMapIndex(this);
        break;
      default:
        index = decodeListIndex(this);
        break;
    }
    if (!this.u57_1.equals(WriteMode_MAP_getInstance())) {
      this.v57_1.c58_1.d5c(index);
    }
    return index;
  };
  protoOf(StreamingJsonDecoder).k1g = function () {
    var tmp;
    if (this.z57_1.x58_1) {
      tmp = this.v57_1.y5e();
    } else {
      tmp = this.v57_1.x5e();
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).l1g = function () {
    var value = this.v57_1.z5e();
    if (!value.equals(toLong_0(value.a3()))) {
      this.v57_1.u5b("Failed to parse byte for input '" + value.toString() + "'");
    }
    return value.a3();
  };
  protoOf(StreamingJsonDecoder).m1g = function () {
    var value = this.v57_1.z5e();
    if (!value.equals(toLong_0(value.b3()))) {
      this.v57_1.u5b("Failed to parse short for input '" + value.toString() + "'");
    }
    return value.b3();
  };
  protoOf(StreamingJsonDecoder).n1g = function () {
    var value = this.v57_1.z5e();
    if (!value.equals(toLong_0(value.c3()))) {
      this.v57_1.u5b("Failed to parse int for input '" + value.toString() + "'");
    }
    return value.c3();
  };
  protoOf(StreamingJsonDecoder).o1g = function () {
    return this.v57_1.z5e();
  };
  protoOf(StreamingJsonDecoder).p1g = function () {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.v57_1;
      var input = this_0.x5c();
      try {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeFloat.<anonymous>' call
        // Inline function 'kotlin.text.toFloat' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$4 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.u5b("Failed to parse type '" + 'float' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$4;
    var specialFp = this.t57_1.p57_1.f59_1;
    if (specialFp || isFinite(result))
      return result;
    throwInvalidFloatingPointDecoded(this.v57_1, result);
  };
  protoOf(StreamingJsonDecoder).q1g = function () {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.v57_1;
      var input = this_0.x5c();
      try {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeDouble.<anonymous>' call
        tmp$ret$1 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.u5b("Failed to parse type '" + 'double' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.t57_1.p57_1.f59_1;
    if (specialFp || isFinite_0(result))
      return result;
    throwInvalidFloatingPointDecoded(this.v57_1, result);
  };
  protoOf(StreamingJsonDecoder).r1g = function () {
    var string = this.v57_1.x5c();
    if (!(string.length === 1)) {
      this.v57_1.u5b("Expected single char, but got '" + string + "'");
    }
    return charSequenceGet(string, 0);
  };
  protoOf(StreamingJsonDecoder).s1g = function () {
    var tmp;
    if (this.z57_1.x58_1) {
      tmp = this.v57_1.q5e();
    } else {
      tmp = this.v57_1.w5c();
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).u1g = function (descriptor) {
    return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.v57_1, this.t57_1) : protoOf(AbstractDecoder).u1g.call(this, descriptor);
  };
  protoOf(StreamingJsonDecoder).t1g = function (enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.t57_1, this.s1g(), ' at path ' + this.v57_1.c58_1.h5c());
  };
  function JsonDecoderForUnsignedTypes(lexer, json) {
    AbstractDecoder.call(this);
    this.a5f_1 = lexer;
    this.b5f_1 = json.o1e();
  }
  protoOf(JsonDecoderForUnsignedTypes).o1e = function () {
    return this.b5f_1;
  };
  protoOf(JsonDecoderForUnsignedTypes).n1h = function (descriptor) {
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(JsonDecoderForUnsignedTypes).n1g = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.a5f_1;
      var input = this_0.x5c();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeInt.<anonymous>' call
        // Inline function 'kotlin.UInt.toInt' call
        var this_1 = toUInt(input);
        tmp$ret$2 = _UInt___get_data__impl__f0vqqw(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.u5b("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).o1g = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.a5f_1;
      var input = this_0.x5c();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeLong.<anonymous>' call
        // Inline function 'kotlin.ULong.toLong' call
        var this_1 = toULong(input);
        tmp$ret$2 = _ULong___get_data__impl__fggpzb(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.u5b("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).l1g = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.a5f_1;
      var input = this_0.x5c();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeByte.<anonymous>' call
        // Inline function 'kotlin.UByte.toByte' call
        var this_1 = toUByte(input);
        tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.u5b("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).m1g = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.a5f_1;
      var input = this_0.x5c();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeShort.<anonymous>' call
        // Inline function 'kotlin.UShort.toShort' call
        var this_1 = toUShort(input);
        tmp$ret$2 = _UShort___get_data__impl__g0245(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.u5b("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  function get_unsignedNumberDescriptors() {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return unsignedNumberDescriptors;
  }
  var unsignedNumberDescriptors;
  function StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, $this) {
    StreamingJsonEncoder.call($this, Composer_0(output, json), json, mode, modeReuseCache);
    return $this;
  }
  function StreamingJsonEncoder_init_$Create$(output, json, mode, modeReuseCache) {
    return StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, objectCreate(protoOf(StreamingJsonEncoder)));
  }
  function encodeTypeInfo($this, descriptor) {
    $this.i5c_1.q5a();
    $this.a1i(ensureNotNull($this.p5c_1));
    $this.i5c_1.s5a(_Char___init__impl__6a9atx(58));
    $this.i5c_1.r5a();
    $this.a1i(descriptor.a1f());
  }
  function StreamingJsonEncoder(composer, json, mode, modeReuseCache) {
    AbstractEncoder.call(this);
    this.i5c_1 = composer;
    this.j5c_1 = json;
    this.k5c_1 = mode;
    this.l5c_1 = modeReuseCache;
    this.m5c_1 = this.j5c_1.o1e();
    this.n5c_1 = this.j5c_1.p57_1;
    this.o5c_1 = false;
    this.p5c_1 = null;
    var i = this.k5c_1.f2_1;
    if (!(this.l5c_1 == null)) {
      if (!(this.l5c_1[i] === null) || !(this.l5c_1[i] === this)) {
        this.l5c_1[i] = this;
      }
    }
  }
  protoOf(StreamingJsonEncoder).i59 = function () {
    return this.j5c_1;
  };
  protoOf(StreamingJsonEncoder).o1e = function () {
    return this.m5c_1;
  };
  protoOf(StreamingJsonEncoder).t1i = function (descriptor, index) {
    return this.n5c_1.v58_1;
  };
  protoOf(StreamingJsonEncoder).o1i = function (serializer, value) {
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
      var tmp;
      if (!(serializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.i59().p57_1.d59_1;
      }
      if (tmp) {
        serializer.u1d(this, value);
        break $l$block;
      }
      var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
      var baseClassDiscriminator = classDiscriminator(serializer.t1d(), this.i59());
      var actualSerializer = findPolymorphicSerializer(casted, this, !(value == null) ? value : THROW_CCE());
      validateIfSealed$accessor$1ad0flx(casted, actualSerializer, baseClassDiscriminator);
      checkKind(actualSerializer.t1d().e1f());
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.encodeSerializableValue.<anonymous>' call
      this.p5c_1 = baseClassDiscriminator;
      actualSerializer.u1d(this, value);
    }
  };
  protoOf(StreamingJsonEncoder).x1g = function (descriptor) {
    var newMode = switchMode(this.j5c_1, descriptor);
    if (!(newMode.u5e_1 === _Char___init__impl__6a9atx(0))) {
      this.i5c_1.s5a(newMode.u5e_1);
      this.i5c_1.o5a();
    }
    if (!(this.p5c_1 == null)) {
      encodeTypeInfo(this, descriptor);
      this.p5c_1 = null;
    }
    if (this.k5c_1.equals(newMode)) {
      return this;
    }
    var tmp0_safe_receiver = this.l5c_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver[newMode.f2_1];
    return tmp1_elvis_lhs == null ? new StreamingJsonEncoder(this.i5c_1, this.j5c_1, newMode, this.l5c_1) : tmp1_elvis_lhs;
  };
  protoOf(StreamingJsonEncoder).y1g = function (descriptor) {
    if (!(this.k5c_1.v5e_1 === _Char___init__impl__6a9atx(0))) {
      this.i5c_1.p5a();
      this.i5c_1.q5a();
      this.i5c_1.s5a(this.k5c_1.v5e_1);
    }
  };
  protoOf(StreamingJsonEncoder).p1h = function (descriptor, index) {
    switch (this.k5c_1.f2_1) {
      case 1:
        if (!this.i5c_1.n5a_1) {
          this.i5c_1.s5a(_Char___init__impl__6a9atx(44));
        }

        this.i5c_1.q5a();
        break;
      case 2:
        if (!this.i5c_1.n5a_1) {
          var tmp = this;
          var tmp_0;
          if ((index % 2 | 0) === 0) {
            this.i5c_1.s5a(_Char___init__impl__6a9atx(44));
            this.i5c_1.q5a();
            tmp_0 = true;
          } else {
            this.i5c_1.s5a(_Char___init__impl__6a9atx(58));
            this.i5c_1.r5a();
            tmp_0 = false;
          }
          tmp.o5c_1 = tmp_0;
        } else {
          this.o5c_1 = true;
          this.i5c_1.q5a();
        }

        break;
      case 3:
        if (index === 0)
          this.o5c_1 = true;
        if (index === 1) {
          this.i5c_1.s5a(_Char___init__impl__6a9atx(44));
          this.i5c_1.r5a();
          this.o5c_1 = false;
        }

        break;
      default:
        if (!this.i5c_1.n5a_1) {
          this.i5c_1.s5a(_Char___init__impl__6a9atx(44));
        }

        this.i5c_1.q5a();
        this.a1i(getJsonElementName(descriptor, this.j5c_1, index));
        this.i5c_1.s5a(_Char___init__impl__6a9atx(58));
        this.i5c_1.r5a();
        break;
    }
    return true;
  };
  protoOf(StreamingJsonEncoder).p1i = function (descriptor, index, serializer, value) {
    if (!(value == null) || this.n5c_1.a59_1) {
      protoOf(AbstractEncoder).p1i.call(this, descriptor, index, serializer, value);
    }
  };
  protoOf(StreamingJsonEncoder).c1i = function (descriptor) {
    var tmp;
    if (get_isUnsignedNumber(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_0;
      var tmp_1 = this.i5c_1;
      if (tmp_1 instanceof ComposerForUnsignedNumbers) {
        tmp_0 = this.i5c_1;
      } else {
        tmp_0 = new ComposerForUnsignedNumbers(this.i5c_1.m5a_1, this.o5c_1);
      }
      var tmp$ret$1 = tmp_0;
      tmp = new StreamingJsonEncoder(tmp$ret$1, this.j5c_1, this.k5c_1, null);
    } else if (get_isUnquotedLiteral(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_2;
      var tmp_3 = this.i5c_1;
      if (tmp_3 instanceof ComposerForUnquotedLiterals) {
        tmp_2 = this.i5c_1;
      } else {
        tmp_2 = new ComposerForUnquotedLiterals(this.i5c_1.m5a_1, this.o5c_1);
      }
      var tmp$ret$3 = tmp_2;
      tmp = new StreamingJsonEncoder(tmp$ret$3, this.j5c_1, this.k5c_1, null);
    } else {
      tmp = protoOf(AbstractEncoder).c1i.call(this, descriptor);
    }
    return tmp;
  };
  protoOf(StreamingJsonEncoder).r1h = function () {
    this.i5c_1.u5a('null');
  };
  protoOf(StreamingJsonEncoder).s1h = function (value) {
    if (this.o5c_1) {
      this.a1i(value.toString());
    } else {
      this.i5c_1.d5b(value);
    }
  };
  protoOf(StreamingJsonEncoder).t1h = function (value) {
    if (this.o5c_1) {
      this.a1i(value.toString());
    } else {
      this.i5c_1.y5a(value);
    }
  };
  protoOf(StreamingJsonEncoder).u1h = function (value) {
    if (this.o5c_1) {
      this.a1i(value.toString());
    } else {
      this.i5c_1.a5b(value);
    }
  };
  protoOf(StreamingJsonEncoder).v1h = function (value) {
    if (this.o5c_1) {
      this.a1i(value.toString());
    } else {
      this.i5c_1.b5b(value);
    }
  };
  protoOf(StreamingJsonEncoder).w1h = function (value) {
    if (this.o5c_1) {
      this.a1i(value.toString());
    } else {
      this.i5c_1.c5b(value);
    }
  };
  protoOf(StreamingJsonEncoder).x1h = function (value) {
    if (this.o5c_1) {
      this.a1i(value.toString());
    } else {
      this.i5c_1.w5a(value);
    }
    if (!this.n5c_1.f59_1 && !isFinite(value)) {
      throw InvalidFloatingPointEncoded(value, toString(this.i5c_1.m5a_1));
    }
  };
  protoOf(StreamingJsonEncoder).y1h = function (value) {
    if (this.o5c_1) {
      this.a1i(value.toString());
    } else {
      this.i5c_1.x5a(value);
    }
    if (!this.n5c_1.f59_1 && !isFinite_0(value)) {
      throw InvalidFloatingPointEncoded(value, toString(this.i5c_1.m5a_1));
    }
  };
  protoOf(StreamingJsonEncoder).z1h = function (value) {
    this.a1i(toString_1(value));
  };
  protoOf(StreamingJsonEncoder).a1i = function (value) {
    return this.i5c_1.e5b(value);
  };
  protoOf(StreamingJsonEncoder).b1i = function (enumDescriptor, index) {
    this.a1i(enumDescriptor.i1f(index));
  };
  function get_isUnsignedNumber(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.d1f() && get_unsignedNumberDescriptors().r(_this__u8e3s4);
  }
  function get_isUnquotedLiteral(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.d1f() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
  }
  var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
  function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
    if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
      properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
      unsignedNumberDescriptors = setOf([serializer_1(Companion_getInstance_0()).t1d(), serializer_0(Companion_getInstance()).t1d(), serializer_2(Companion_getInstance_1()).t1d(), serializer_3(Companion_getInstance_2()).t1d()]);
    }
  }
  function get_ESCAPE_STRINGS() {
    _init_properties_StringOps_kt__fcy1db();
    return ESCAPE_STRINGS;
  }
  var ESCAPE_STRINGS;
  var ESCAPE_MARKERS;
  function toHexChar(i) {
    _init_properties_StringOps_kt__fcy1db();
    var d = i & 15;
    var tmp;
    if (d < 10) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      tmp = numberToChar(d + tmp$ret$0 | 0);
    } else {
      var tmp_0 = d - 10 | 0;
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(97);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
    }
    return tmp;
  }
  function printQuoted(_this__u8e3s4, value) {
    _init_properties_StringOps_kt__fcy1db();
    _this__u8e3s4.p7(_Char___init__impl__6a9atx(34));
    var lastPos = 0;
    var inductionVariable = 0;
    var last = charSequenceLength(value) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charSequenceGet(value, i);
        var c = Char__toInt_impl_vasixd(this_0);
        if (c < get_ESCAPE_STRINGS().length && !(get_ESCAPE_STRINGS()[c] == null)) {
          _this__u8e3s4.ab(value, lastPos, i);
          _this__u8e3s4.o7(get_ESCAPE_STRINGS()[c]);
          lastPos = i + 1 | 0;
        }
      }
       while (inductionVariable <= last);
    if (!(lastPos === 0)) {
      _this__u8e3s4.ab(value, lastPos, value.length);
    } else {
      _this__u8e3s4.o7(value);
    }
    _this__u8e3s4.p7(_Char___init__impl__6a9atx(34));
  }
  function toBooleanStrictOrNull(_this__u8e3s4) {
    _init_properties_StringOps_kt__fcy1db();
    return equals_0(_this__u8e3s4, 'true', true) ? true : equals_0(_this__u8e3s4, 'false', true) ? false : null;
  }
  var properties_initialized_StringOps_kt_wzaea7;
  function _init_properties_StringOps_kt__fcy1db() {
    if (!properties_initialized_StringOps_kt_wzaea7) {
      properties_initialized_StringOps_kt_wzaea7 = true;
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.arrayOfNulls' call
      var this_0 = fillArrayVal(Array(93), null);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.ESCAPE_STRINGS.<anonymous>' call
      var inductionVariable = 0;
      if (inductionVariable <= 31)
        do {
          var c = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var c1 = toHexChar(c >> 12);
          var c2 = toHexChar(c >> 8);
          var c3 = toHexChar(c >> 4);
          var c4 = toHexChar(c);
          this_0[c] = '\\u' + toString_1(c1) + toString_1(c2) + toString_1(c3) + toString_1(c4);
        }
         while (inductionVariable <= 31);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(34);
      this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(92);
      this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(9);
      this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(8);
      this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(10);
      this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
      // Inline function 'kotlin.code' call
      var this_6 = _Char___init__impl__6a9atx(13);
      this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
      this_0[12] = '\\f';
      ESCAPE_STRINGS = this_0;
      // Inline function 'kotlin.apply' call
      var this_7 = new Int8Array(93);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.ESCAPE_MARKERS.<anonymous>' call
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= 31)
        do {
          var c_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this_7[c_0] = 1;
        }
         while (inductionVariable_0 <= 31);
      // Inline function 'kotlin.code' call
      var this_8 = _Char___init__impl__6a9atx(34);
      this_7[Char__toInt_impl_vasixd(this_8)] = 34;
      // Inline function 'kotlin.code' call
      var this_9 = _Char___init__impl__6a9atx(92);
      this_7[Char__toInt_impl_vasixd(this_9)] = 92;
      // Inline function 'kotlin.code' call
      var this_10 = _Char___init__impl__6a9atx(9);
      this_7[Char__toInt_impl_vasixd(this_10)] = 116;
      // Inline function 'kotlin.code' call
      var this_11 = _Char___init__impl__6a9atx(8);
      this_7[Char__toInt_impl_vasixd(this_11)] = 98;
      // Inline function 'kotlin.code' call
      var this_12 = _Char___init__impl__6a9atx(10);
      this_7[Char__toInt_impl_vasixd(this_12)] = 110;
      // Inline function 'kotlin.code' call
      var this_13 = _Char___init__impl__6a9atx(13);
      this_7[Char__toInt_impl_vasixd(this_13)] = 114;
      this_7[12] = 102;
      ESCAPE_MARKERS = this_7;
    }
  }
  function currentObject($this) {
    var tmp0_safe_receiver = $this.c1v();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.currentObject.<anonymous>' call
      tmp = $this.h5f(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? $this.v() : tmp1_elvis_lhs;
  }
  function unparsedPrimitive($this, primitive) {
    throw JsonDecodingException_0(-1, "Failed to parse '" + primitive + "'", toString(currentObject($this)));
  }
  function asLiteral(_this__u8e3s4, $this, type) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonLiteral ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw JsonDecodingException_1(-1, "Unexpected 'null' when " + type + ' was expected');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function AbstractJsonTreeDecoder(json, value) {
    NamedValueDecoder.call(this);
    this.e5f_1 = json;
    this.f5f_1 = value;
    this.g5f_1 = this.i59().p57_1;
  }
  protoOf(AbstractJsonTreeDecoder).i59 = function () {
    return this.e5f_1;
  };
  protoOf(AbstractJsonTreeDecoder).v = function () {
    return this.f5f_1;
  };
  protoOf(AbstractJsonTreeDecoder).o1e = function () {
    return this.i59().o1e();
  };
  protoOf(AbstractJsonTreeDecoder).j59 = function () {
    return currentObject(this);
  };
  protoOf(AbstractJsonTreeDecoder).w1g = function (deserializer) {
    return decodeSerializableValuePolymorphic(this, deserializer);
  };
  protoOf(AbstractJsonTreeDecoder).d1v = function (parentName, childName) {
    return childName;
  };
  protoOf(AbstractJsonTreeDecoder).x1g = function (descriptor) {
    var currentObject_0 = currentObject(this);
    var tmp0_subject = descriptor.e1f();
    var tmp;
    var tmp_0;
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = tmp0_subject instanceof PolymorphicKind;
    }
    if (tmp_0) {
      var tmp_1 = this.i59();
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      if (!(currentObject_0 instanceof JsonArray)) {
        throw JsonDecodingException_1(-1, 'Expected ' + toString(getKClass(JsonArray)) + ' as the serialized body of ' + descriptor.a1f() + ', but had ' + toString(getKClassFromExpression(currentObject_0)));
      }
      tmp = new JsonTreeListDecoder(tmp_1, currentObject_0);
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var this_0 = this.i59();
        var keyDescriptor = carrierDescriptor(descriptor.g1f(0), this_0.o1e());
        var keyKind = keyDescriptor.e1f();
        var tmp_2;
        var tmp_3;
        if (keyKind instanceof PrimitiveKind) {
          tmp_3 = true;
        } else {
          tmp_3 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_3) {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
          var tmp_4 = this.i59();
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          if (!(currentObject_0 instanceof JsonObject)) {
            throw JsonDecodingException_1(-1, 'Expected ' + toString(getKClass(JsonObject)) + ' as the serialized body of ' + descriptor.a1f() + ', but had ' + toString(getKClassFromExpression(currentObject_0)));
          }
          tmp_2 = new JsonTreeMapDecoder(tmp_4, currentObject_0);
        } else {
          if (this_0.p57_1.y58_1) {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
            var tmp_5 = this.i59();
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            if (!(currentObject_0 instanceof JsonArray)) {
              throw JsonDecodingException_1(-1, 'Expected ' + toString(getKClass(JsonArray)) + ' as the serialized body of ' + descriptor.a1f() + ', but had ' + toString(getKClassFromExpression(currentObject_0)));
            }
            tmp_2 = new JsonTreeListDecoder(tmp_5, currentObject_0);
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_2;
      } else {
        var tmp_6 = this.i59();
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        if (!(currentObject_0 instanceof JsonObject)) {
          throw JsonDecodingException_1(-1, 'Expected ' + toString(getKClass(JsonObject)) + ' as the serialized body of ' + descriptor.a1f() + ', but had ' + toString(getKClassFromExpression(currentObject_0)));
        }
        tmp = new JsonTreeDecoder(tmp_6, currentObject_0);
      }
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).y1g = function (descriptor) {
  };
  protoOf(AbstractJsonTreeDecoder).i1g = function () {
    var tmp = currentObject(this);
    return !(tmp instanceof JsonNull);
  };
  protoOf(AbstractJsonTreeDecoder).i5f = function (tag) {
    var currentElement = this.h5f(tag);
    var tmp0_elvis_lhs = currentElement instanceof JsonPrimitive ? currentElement : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw JsonDecodingException_0(-1, 'Expected JsonPrimitive at ' + tag + ', found ' + toString(currentElement), toString(currentObject(this)));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).j5f = function (tag, enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.i59(), this.i5f(tag).k3w());
  };
  protoOf(AbstractJsonTreeDecoder).p1v = function (tag, enumDescriptor) {
    return this.j5f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).k5f = function (tag) {
    return !(this.h5f(tag) === JsonNull_getInstance());
  };
  protoOf(AbstractJsonTreeDecoder).f1v = function (tag) {
    return this.k5f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).l5f = function (tag) {
    var value = this.i5f(tag);
    if (!this.i59().p57_1.x58_1) {
      var literal = asLiteral(value, this, 'boolean');
      if (literal.o59_1)
        throw JsonDecodingException_0(-1, "Boolean literal for key '" + tag + "' should be unquoted.\nUse 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.", toString(currentObject(this)));
    }
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedBoolean.<anonymous>' call
        var tmp0_elvis_lhs = get_booleanOrNull(value);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalArgumentException_init_$Create$_0();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp0_elvis_lhs_0 = tmp;
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          unparsedPrimitive(this, 'boolean');
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        tmp$ret$1 = tmp_0;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'boolean');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).g1v = function (tag) {
    return this.l5f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).m5f = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var this_0 = this.i5f(tag);
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedByte.<anonymous>' call
        var result = get_int(this_0);
        var tmp0_elvis_lhs = (-128 <= result ? result <= 127 : false) ? toByte(result) : null;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'byte');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'byte');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).h1v = function (tag) {
    return this.m5f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).n5f = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var this_0 = this.i5f(tag);
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedShort.<anonymous>' call
        var result = get_int(this_0);
        var tmp0_elvis_lhs = (-32768 <= result ? result <= 32767 : false) ? toShort(result) : null;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'short');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'short');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).i1v = function (tag) {
    return this.n5f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).o5f = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var this_0 = this.i5f(tag);
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedInt.<anonymous>' call
        var tmp0_elvis_lhs = get_int(this_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'int');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'int');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).j1v = function (tag) {
    return this.o5f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).p5f = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var this_0 = this.i5f(tag);
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedLong.<anonymous>' call
        var tmp0_elvis_lhs = get_long(this_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'long');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'long');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).k1v = function (tag) {
    return this.p5f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).q5f = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var this_0 = this.i5f(tag);
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedFloat.<anonymous>' call
        var tmp0_elvis_lhs = get_float(this_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'float');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'float');
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.i59().p57_1.f59_1;
    if (specialFp || isFinite(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(currentObject(this)));
  };
  protoOf(AbstractJsonTreeDecoder).l1v = function (tag) {
    return this.q5f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).r5f = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var this_0 = this.i5f(tag);
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedDouble.<anonymous>' call
        var tmp0_elvis_lhs = get_double(this_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'double');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'double');
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.i59().p57_1.f59_1;
    if (specialFp || isFinite_0(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(currentObject(this)));
  };
  protoOf(AbstractJsonTreeDecoder).m1v = function (tag) {
    return this.r5f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).s5f = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var this_0 = this.i5f(tag);
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedChar.<anonymous>' call
        var tmp0_elvis_lhs = new Char(single(this_0.k3w()));
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'char');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp.f1_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'char');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).n1v = function (tag) {
    return this.s5f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).t5f = function (tag) {
    var value = this.i5f(tag);
    if (!this.i59().p57_1.x58_1) {
      var literal = asLiteral(value, this, 'string');
      if (!literal.o59_1)
        throw JsonDecodingException_0(-1, "String literal for key '" + tag + "' should be quoted.\nUse 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.", toString(currentObject(this)));
    }
    if (value instanceof JsonNull)
      throw JsonDecodingException_0(-1, "Unexpected 'null' value instead of string literal", toString(currentObject(this)));
    return value.k3w();
  };
  protoOf(AbstractJsonTreeDecoder).o1v = function (tag) {
    return this.t5f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).u5f = function (tag, inlineDescriptor) {
    return get_isUnsignedNumber(inlineDescriptor) ? new JsonDecoderForUnsignedTypes(new StringJsonLexer(this.i5f(tag).k3w()), this.i59()) : protoOf(NamedValueDecoder).q1v.call(this, tag, inlineDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).q1v = function (tag, inlineDescriptor) {
    return this.u5f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).u1g = function (descriptor) {
    return !(this.c1v() == null) ? protoOf(NamedValueDecoder).u1g.call(this, descriptor) : (new JsonPrimitiveDecoder(this.i59(), this.v())).u1g(descriptor);
  };
  function coerceInputValue_0($this, descriptor, index, tag) {
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var this_0 = $this.i59();
      var elementDescriptor = descriptor.g1f(index);
      var tmp;
      if (!elementDescriptor.w1e()) {
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
        var tmp_0 = $this.h5f(tag);
        tmp = tmp_0 instanceof JsonNull;
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$1 = true;
        break $l$block_2;
      }
      if (equals(elementDescriptor.e1f(), ENUM_getInstance())) {
        var tmp_1;
        if (elementDescriptor.w1e()) {
          // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
          var tmp_2 = $this.h5f(tag);
          tmp_1 = tmp_2 instanceof JsonNull;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$1 = false;
          break $l$block_2;
        }
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
        var tmp_3 = $this.h5f(tag);
        var tmp0_safe_receiver = tmp_3 instanceof JsonPrimitive ? tmp_3 : null;
        var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
        var tmp_4;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$1 = false;
          break $l$block_2;
        } else {
          tmp_4 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_4;
        var enumIndex = getJsonNameIndex(elementDescriptor, this_0, enumValue);
        if (enumIndex === -3) {
          // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue.<anonymous>' call
          tmp$ret$1 = true;
          break $l$block_2;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function absenceIsNull($this, descriptor, index) {
    $this.e5g_1 = (!$this.i59().p57_1.a59_1 && !descriptor.j1f(index) && descriptor.g1f(index).w1e());
    return $this.e5g_1;
  }
  function JsonTreeDecoder(json, value, polyDiscriminator, polyDescriptor) {
    polyDiscriminator = polyDiscriminator === VOID ? null : polyDiscriminator;
    polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
    AbstractJsonTreeDecoder.call(this, json, value);
    this.a5g_1 = value;
    this.b5g_1 = polyDiscriminator;
    this.c5g_1 = polyDescriptor;
    this.d5g_1 = 0;
    this.e5g_1 = false;
  }
  protoOf(JsonTreeDecoder).v = function () {
    return this.a5g_1;
  };
  protoOf(JsonTreeDecoder).n1h = function (descriptor) {
    while (this.d5g_1 < descriptor.c1f()) {
      var tmp1 = this.d5g_1;
      this.d5g_1 = tmp1 + 1 | 0;
      var name = this.x1u(descriptor, tmp1);
      var index = this.d5g_1 - 1 | 0;
      this.e5g_1 = false;
      var tmp;
      var tmp_0;
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_0 = this.v();
      if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w1(name)) {
        tmp_0 = true;
      } else {
        tmp_0 = absenceIsNull(this, descriptor, index);
      }
      if (tmp_0) {
        tmp = !this.g5f_1.c59_1 || !coerceInputValue_0(this, descriptor, index, name);
      } else {
        tmp = false;
      }
      if (tmp) {
        return index;
      }
    }
    return -1;
  };
  protoOf(JsonTreeDecoder).i1g = function () {
    return !this.e5g_1 && protoOf(AbstractJsonTreeDecoder).i1g.call(this);
  };
  protoOf(JsonTreeDecoder).y1u = function (descriptor, index) {
    var strategy = namingStrategy(descriptor, this.i59());
    var baseName = descriptor.i1f(index);
    if (strategy == null) {
      if (!this.g5f_1.g59_1)
        return baseName;
      if (this.v().z1().r(baseName))
        return baseName;
    }
    var deserializationNamesMap_0 = deserializationNamesMap(this.i59(), descriptor);
    // Inline function 'kotlin.collections.find' call
    var this_0 = this.v().z1();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this_0.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.elementName.<anonymous>' call
        if (deserializationNamesMap_0.y1(element) === index) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp0_safe_receiver;
    }
    var fallbackName = strategy == null ? null : strategy.y5b(descriptor, index, baseName);
    return fallbackName == null ? baseName : fallbackName;
  };
  protoOf(JsonTreeDecoder).h5f = function (tag) {
    return getValue(this.v(), tag);
  };
  protoOf(JsonTreeDecoder).x1g = function (descriptor) {
    if (descriptor === this.c5g_1)
      return this;
    return protoOf(AbstractJsonTreeDecoder).x1g.call(this, descriptor);
  };
  protoOf(JsonTreeDecoder).y1g = function (descriptor) {
    var tmp;
    if (this.g5f_1.w58_1) {
      tmp = true;
    } else {
      var tmp_0 = descriptor.e1f();
      tmp = tmp_0 instanceof PolymorphicKind;
    }
    if (tmp)
      return Unit_instance;
    var strategy = namingStrategy(descriptor, this.i59());
    var tmp_1;
    if (strategy == null && !this.g5f_1.g59_1) {
      tmp_1 = jsonCachedSerialNames(descriptor);
    } else if (!(strategy == null)) {
      tmp_1 = deserializationNamesMap(this.i59(), descriptor).z1();
    } else {
      var tmp_2 = jsonCachedSerialNames(descriptor);
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_safe_receiver = get_schemaCache(this.i59()).h5e(descriptor, get_JsonDeserializationNamesKey());
      var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z1();
      var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
      tmp_1 = plus_0(tmp_2, tmp$ret$0);
    }
    var names = tmp_1;
    var tmp1_iterator = this.v().z1().g();
    while (tmp1_iterator.h()) {
      var key = tmp1_iterator.i();
      if (!names.r(key) && !(key === this.b5g_1)) {
        throw UnknownKeyException(key, this.v().toString());
      }
    }
  };
  function JsonTreeListDecoder(json, value) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this.k5g_1 = value;
    this.l5g_1 = this.k5g_1.j();
    this.m5g_1 = -1;
  }
  protoOf(JsonTreeListDecoder).v = function () {
    return this.k5g_1;
  };
  protoOf(JsonTreeListDecoder).y1u = function (descriptor, index) {
    return index.toString();
  };
  protoOf(JsonTreeListDecoder).h5f = function (tag) {
    return this.k5g_1.p(toInt(tag));
  };
  protoOf(JsonTreeListDecoder).n1h = function (descriptor) {
    while (this.m5g_1 < (this.l5g_1 - 1 | 0)) {
      this.m5g_1 = this.m5g_1 + 1 | 0;
      return this.m5g_1;
    }
    return -1;
  };
  function JsonPrimitiveDecoder(json, value) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this.s5g_1 = value;
    this.r1v('primitive');
  }
  protoOf(JsonPrimitiveDecoder).v = function () {
    return this.s5g_1;
  };
  protoOf(JsonPrimitiveDecoder).n1h = function (descriptor) {
    return 0;
  };
  protoOf(JsonPrimitiveDecoder).h5f = function (tag) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(tag === 'primitive')) {
      // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveDecoder.currentElement.<anonymous>' call
      var message = "This input can only handle primitives with 'primitive' tag";
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.s5g_1;
  };
  function JsonTreeMapDecoder(json, value) {
    JsonTreeDecoder.call(this, json, value);
    this.d5h_1 = value;
    this.e5h_1 = toList(this.d5h_1.z1());
    this.f5h_1 = imul(this.e5h_1.j(), 2);
    this.g5h_1 = -1;
  }
  protoOf(JsonTreeMapDecoder).v = function () {
    return this.d5h_1;
  };
  protoOf(JsonTreeMapDecoder).y1u = function (descriptor, index) {
    var i = index / 2 | 0;
    return this.e5h_1.p(i);
  };
  protoOf(JsonTreeMapDecoder).n1h = function (descriptor) {
    while (this.g5h_1 < (this.f5h_1 - 1 | 0)) {
      this.g5h_1 = this.g5h_1 + 1 | 0;
      return this.g5h_1;
    }
    return -1;
  };
  protoOf(JsonTreeMapDecoder).h5f = function (tag) {
    return (this.g5h_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.d5h_1, tag);
  };
  protoOf(JsonTreeMapDecoder).y1g = function (descriptor) {
  };
  function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
    return (new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.t1d())).w1g(deserializer);
  }
  var WriteMode_OBJ_instance;
  var WriteMode_LIST_instance;
  var WriteMode_MAP_instance;
  var WriteMode_POLY_OBJ_instance;
  function values() {
    return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
  }
  var WriteMode_entriesInitialized;
  function WriteMode_initEntries() {
    if (WriteMode_entriesInitialized)
      return Unit_instance;
    WriteMode_entriesInitialized = true;
    WriteMode_OBJ_instance = new WriteMode('OBJ', 0, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
    WriteMode_LIST_instance = new WriteMode('LIST', 1, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
    WriteMode_MAP_instance = new WriteMode('MAP', 2, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
    WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
  }
  function WriteMode(name, ordinal, begin, end) {
    Enum.call(this, name, ordinal);
    this.u5e_1 = begin;
    this.v5e_1 = end;
  }
  function switchMode(_this__u8e3s4, desc) {
    var tmp0_subject = desc.e1f();
    var tmp;
    if (tmp0_subject instanceof PolymorphicKind) {
      tmp = WriteMode_POLY_OBJ_getInstance();
    } else {
      if (equals(tmp0_subject, LIST_getInstance())) {
        tmp = WriteMode_LIST_getInstance();
      } else {
        if (equals(tmp0_subject, MAP_getInstance())) {
          // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
          var keyDescriptor = carrierDescriptor(desc.g1f(0), _this__u8e3s4.o1e());
          var keyKind = keyDescriptor.e1f();
          var tmp_0;
          var tmp_1;
          if (keyKind instanceof PrimitiveKind) {
            tmp_1 = true;
          } else {
            tmp_1 = equals(keyKind, ENUM_getInstance());
          }
          if (tmp_1) {
            // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
            tmp_0 = WriteMode_MAP_getInstance();
          } else {
            if (_this__u8e3s4.p57_1.y58_1) {
              // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
              tmp_0 = WriteMode_LIST_getInstance();
            } else {
              throw InvalidKeyKindException(keyDescriptor);
            }
          }
          tmp = tmp_0;
        } else {
          tmp = WriteMode_OBJ_getInstance();
        }
      }
    }
    return tmp;
  }
  function carrierDescriptor(_this__u8e3s4, module_0) {
    var tmp;
    if (equals(_this__u8e3s4.e1f(), CONTEXTUAL_getInstance())) {
      var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
      tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
    } else if (_this__u8e3s4.d1f()) {
      tmp = carrierDescriptor(_this__u8e3s4.g1f(0), module_0);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function WriteMode_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_OBJ_instance;
  }
  function WriteMode_LIST_getInstance() {
    WriteMode_initEntries();
    return WriteMode_LIST_instance;
  }
  function WriteMode_MAP_getInstance() {
    WriteMode_initEntries();
    return WriteMode_MAP_instance;
  }
  function WriteMode_POLY_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_POLY_OBJ_instance;
  }
  function appendEscape($this, lastPosition, current) {
    $this.h5h(lastPosition, current);
    return appendEsc($this, current + 1 | 0);
  }
  function decodedString($this, lastPosition, currentPosition) {
    $this.h5h(lastPosition, currentPosition);
    var result = $this.e58_1.toString();
    $this.e58_1.fb(0);
    return result;
  }
  function takePeeked($this) {
    // Inline function 'kotlin.also' call
    var this_0 = ensureNotNull($this.d58_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.takePeeked.<anonymous>' call
    $this.d58_1 = null;
    return this_0;
  }
  function wasUnquotedString($this) {
    return !(charSequenceGet($this.i5h(), $this.b58_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
  }
  function appendEsc($this, startPosition) {
    var currentPosition = startPosition;
    currentPosition = $this.j5h(currentPosition);
    if (currentPosition === -1) {
      $this.u5b('Expected escape sequence to continue, got EOF');
    }
    var tmp = $this.i5h();
    var tmp0 = currentPosition;
    currentPosition = tmp0 + 1 | 0;
    var currentChar = charSequenceGet(tmp, tmp0);
    if (currentChar === _Char___init__impl__6a9atx(117)) {
      return appendHex($this, $this.i5h(), currentPosition);
    }
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
    var c = escapeToChar(tmp$ret$0);
    if (c === _Char___init__impl__6a9atx(0)) {
      $this.u5b("Invalid escaped char '" + toString_1(currentChar) + "'");
    }
    $this.e58_1.p7(c);
    return currentPosition;
  }
  function appendHex($this, source, startPos) {
    if ((startPos + 4 | 0) >= charSequenceLength(source)) {
      $this.b58_1 = startPos;
      $this.k5h();
      if (($this.b58_1 + 4 | 0) >= charSequenceLength(source)) {
        $this.u5b('Unexpected EOF during unicode escape');
      }
      return appendHex($this, source, $this.b58_1);
    }
    $this.e58_1.p7(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
    return startPos + 4 | 0;
  }
  function fromHexChar($this, source, currentPosition) {
    var character = charSequenceGet(source, currentPosition);
    var tmp;
    if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
      // Inline function 'kotlin.code' call
      var tmp_0 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
    } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
      // Inline function 'kotlin.code' call
      var tmp_1 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(97);
      tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
    } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
      // Inline function 'kotlin.code' call
      var tmp_2 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
    } else {
      $this.u5b("Invalid toHexChar char '" + toString_1(character) + "' in unicode escape");
    }
    return tmp;
  }
  function consumeBoolean2($this, start) {
    var current = $this.j5h(start);
    if (current >= charSequenceLength($this.i5h()) || current === -1) {
      $this.u5b('EOF');
    }
    // Inline function 'kotlin.code' call
    var tmp = $this.i5h();
    var tmp0 = current;
    current = tmp0 + 1 | 0;
    var this_0 = charSequenceGet(tmp, tmp0);
    var tmp1_subject = Char__toInt_impl_vasixd(this_0) | 32;
    var tmp_0;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(116);
    if (tmp1_subject === Char__toInt_impl_vasixd(this_1)) {
      consumeBooleanLiteral($this, 'rue', current);
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(102);
      if (tmp1_subject === Char__toInt_impl_vasixd(this_2)) {
        consumeBooleanLiteral($this, 'alse', current);
        tmp_0 = false;
      } else {
        $this.u5b("Expected valid boolean literal prefix, but had '" + $this.x5c() + "'");
      }
    }
    return tmp_0;
  }
  function consumeBooleanLiteral($this, literalSuffix, current) {
    if ((charSequenceLength($this.i5h()) - current | 0) < literalSuffix.length) {
      $this.u5b('Unexpected end of boolean literal');
    }
    var inductionVariable = 0;
    var last = charSequenceLength(literalSuffix) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var expected = charSequenceGet(literalSuffix, i);
        var actual = charSequenceGet($this.i5h(), current + i | 0);
        // Inline function 'kotlin.code' call
        var tmp = Char__toInt_impl_vasixd(expected);
        // Inline function 'kotlin.code' call
        if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) {
          $this.u5b("Expected valid boolean literal prefix, but had '" + $this.x5c() + "'");
        }
      }
       while (inductionVariable <= last);
    $this.b58_1 = current + literalSuffix.length | 0;
  }
  function AbstractJsonLexer() {
    this.b58_1 = 0;
    this.c58_1 = new JsonPath();
    this.d58_1 = null;
    this.e58_1 = StringBuilder_init_$Create$();
  }
  protoOf(AbstractJsonLexer).k5h = function () {
  };
  protoOf(AbstractJsonLexer).l5h = function (c) {
    return (((c === _Char___init__impl__6a9atx(125) ? true : c === _Char___init__impl__6a9atx(93)) ? true : c === _Char___init__impl__6a9atx(58)) ? true : c === _Char___init__impl__6a9atx(44)) ? false : true;
  };
  protoOf(AbstractJsonLexer).f58 = function () {
    var nextToken = this.z5c();
    if (!(nextToken === 10)) {
      this.u5b('Expected EOF after parsing, but had ' + toString_1(charSequenceGet(this.i5h(), this.b58_1 - 1 | 0)) + ' instead');
    }
  };
  protoOf(AbstractJsonLexer).t5c = function (expected) {
    var token = this.z5c();
    if (!(token === expected)) {
      this.m5h(expected);
    }
    return token;
  };
  protoOf(AbstractJsonLexer).j5e = function (expected) {
    this.k5h();
    var source = this.i5h();
    var cpos = this.b58_1;
    $l$loop_0: while (true) {
      cpos = this.j5h(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var tmp0 = cpos;
      cpos = tmp0 + 1 | 0;
      var c = charSequenceGet(source, tmp0);
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop_0;
      this.b58_1 = cpos;
      if (c === expected)
        return Unit_instance;
      this.n5h(expected);
    }
    this.b58_1 = cpos;
    this.n5h(expected);
  };
  protoOf(AbstractJsonLexer).n5h = function (expected) {
    this.b58_1 = this.b58_1 - 1 | 0;
    if (this.b58_1 >= 0 && expected === _Char___init__impl__6a9atx(34) && this.x5c() === 'null') {
      this.o5h("Expected string literal but 'null' literal was found", this.b58_1 - 4 | 0, "Use 'coerceInputValues = true' in 'Json {}` builder to coerce nulls to default values.");
    }
    this.m5h(charToTokenClass(expected));
  };
  protoOf(AbstractJsonLexer).m5h = function (expectedToken) {
    var expected = expectedToken === 1 ? "quotation mark '\"'" : expectedToken === 4 ? "comma ','" : expectedToken === 5 ? "colon ':'" : expectedToken === 6 ? "start of the object '{'" : expectedToken === 7 ? "end of the object '}'" : expectedToken === 8 ? "start of the array '['" : expectedToken === 9 ? "end of the array ']'" : 'valid token';
    var s = this.b58_1 === charSequenceLength(this.i5h()) || this.b58_1 <= 0 ? 'EOF' : toString_1(charSequenceGet(this.i5h(), this.b58_1 - 1 | 0));
    this.u5b('Expected ' + expected + ", but had '" + s + "' instead", this.b58_1 - 1 | 0);
  };
  protoOf(AbstractJsonLexer).u5c = function () {
    var source = this.i5h();
    var cpos = this.b58_1;
    $l$loop_0: while (true) {
      cpos = this.j5h(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var ch = charSequenceGet(source, cpos);
      if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(10) || ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(9)) {
        cpos = cpos + 1 | 0;
        continue $l$loop_0;
      }
      this.b58_1 = cpos;
      return charToTokenClass(ch);
    }
    this.b58_1 = cpos;
    return 10;
  };
  protoOf(AbstractJsonLexer).l5e = function (doConsume) {
    var current = this.p5h();
    current = this.j5h(current);
    var len = charSequenceLength(this.i5h()) - current | 0;
    if (len < 4 || current === -1)
      return false;
    var inductionVariable = 0;
    if (inductionVariable <= 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(charSequenceGet('null', i) === charSequenceGet(this.i5h(), current + i | 0)))
          return false;
      }
       while (inductionVariable <= 3);
    if (len > 4 && charToTokenClass(charSequenceGet(this.i5h(), current + 4 | 0)) === 0)
      return false;
    if (doConsume) {
      this.b58_1 = current + 4 | 0;
    }
    return true;
  };
  protoOf(AbstractJsonLexer).w5e = function (doConsume, $super) {
    doConsume = doConsume === VOID ? true : doConsume;
    return $super === VOID ? this.l5e(doConsume) : $super.l5e.call(this, doConsume);
  };
  protoOf(AbstractJsonLexer).p5h = function () {
    var current = this.b58_1;
    $l$loop_0: while (true) {
      current = this.j5h(current);
      if (current === -1)
        break $l$loop_0;
      var c = charSequenceGet(this.i5h(), current);
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
      } else {
        break $l$loop_0;
      }
    }
    this.b58_1 = current;
    return current;
  };
  protoOf(AbstractJsonLexer).m5e = function (isLenient) {
    var token = this.u5c();
    var tmp;
    if (isLenient) {
      if (!(token === 1) && !(token === 0))
        return null;
      tmp = this.x5c();
    } else {
      if (!(token === 1))
        return null;
      tmp = this.w5c();
    }
    var string = tmp;
    this.d58_1 = string;
    return string;
  };
  protoOf(AbstractJsonLexer).q5h = function (startPos, endPos) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.i5h();
    return toString(charSequenceSubSequence(this_0, startPos, endPos));
  };
  protoOf(AbstractJsonLexer).w5c = function () {
    if (!(this.d58_1 == null)) {
      return takePeeked(this);
    }
    return this.p5e();
  };
  protoOf(AbstractJsonLexer).consumeString2 = function (source, startPosition, current) {
    var currentPosition = current;
    var lastPosition = startPosition;
    var char = charSequenceGet(source, currentPosition);
    var usedAppend = false;
    while (!(char === _Char___init__impl__6a9atx(34))) {
      if (char === _Char___init__impl__6a9atx(92)) {
        usedAppend = true;
        currentPosition = this.j5h(appendEscape(this, lastPosition, currentPosition));
        if (currentPosition === -1) {
          this.u5b('EOF', currentPosition);
        }
        lastPosition = currentPosition;
      } else {
        currentPosition = currentPosition + 1 | 0;
        if (currentPosition >= charSequenceLength(source)) {
          usedAppend = true;
          this.h5h(lastPosition, currentPosition);
          currentPosition = this.j5h(currentPosition);
          if (currentPosition === -1) {
            this.u5b('EOF', currentPosition);
          }
          lastPosition = currentPosition;
        }
      }
      char = charSequenceGet(source, currentPosition);
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.q5h(lastPosition, currentPosition);
    } else {
      tmp = decodedString(this, lastPosition, currentPosition);
    }
    var string = tmp;
    this.b58_1 = currentPosition + 1 | 0;
    return string;
  };
  protoOf(AbstractJsonLexer).q5e = function () {
    var result = this.x5c();
    if (result === 'null' && wasUnquotedString(this)) {
      this.u5b("Unexpected 'null' value instead of string literal");
    }
    return result;
  };
  protoOf(AbstractJsonLexer).x5c = function () {
    if (!(this.d58_1 == null)) {
      return takePeeked(this);
    }
    var current = this.p5h();
    if (current >= charSequenceLength(this.i5h()) || current === -1) {
      this.u5b('EOF', current);
    }
    var token = charToTokenClass(charSequenceGet(this.i5h(), current));
    if (token === 1) {
      return this.w5c();
    }
    if (!(token === 0)) {
      this.u5b('Expected beginning of the string, but got ' + toString_1(charSequenceGet(this.i5h(), current)));
    }
    var usedAppend = false;
    while (charToTokenClass(charSequenceGet(this.i5h(), current)) === 0) {
      current = current + 1 | 0;
      if (current >= charSequenceLength(this.i5h())) {
        usedAppend = true;
        this.h5h(this.b58_1, current);
        var eof = this.j5h(current);
        if (eof === -1) {
          this.b58_1 = current;
          return decodedString(this, 0, 0);
        } else {
          current = eof;
        }
      }
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.q5h(this.b58_1, current);
    } else {
      tmp = decodedString(this, this.b58_1, current);
    }
    var result = tmp;
    this.b58_1 = current;
    return result;
  };
  protoOf(AbstractJsonLexer).h5h = function (fromIndex, toIndex) {
    this.e58_1.ab(this.i5h(), fromIndex, toIndex);
  };
  protoOf(AbstractJsonLexer).o5e = function (allowLenientStrings) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var tokenStack = ArrayList_init_$Create$();
    var lastToken = this.u5c();
    if (!(lastToken === 8) && !(lastToken === 6)) {
      this.x5c();
      return Unit_instance;
    }
    $l$loop: while (true) {
      lastToken = this.u5c();
      if (lastToken === 1) {
        if (allowLenientStrings) {
          this.x5c();
        } else {
          this.p5e();
        }
        continue $l$loop;
      }
      var tmp0_subject = lastToken;
      if (tmp0_subject === 8 ? true : tmp0_subject === 6) {
        tokenStack.e(lastToken);
      } else if (tmp0_subject === 9) {
        if (!(last(tokenStack) === 8))
          throw JsonDecodingException_0(this.b58_1, 'found ] instead of } at path: ' + this.c58_1.toString(), this.i5h());
        removeLast(tokenStack);
      } else if (tmp0_subject === 7) {
        if (!(last(tokenStack) === 6))
          throw JsonDecodingException_0(this.b58_1, 'found } instead of ] at path: ' + this.c58_1.toString(), this.i5h());
        removeLast(tokenStack);
      } else if (tmp0_subject === 10) {
        this.u5b('Unexpected end of input due to malformed JSON during ignoring unknown keys');
      }
      this.z5c();
      if (tokenStack.j() === 0)
        return Unit_instance;
    }
  };
  protoOf(AbstractJsonLexer).toString = function () {
    return "JsonReader(source='" + toString(this.i5h()) + "', currentPosition=" + this.b58_1 + ')';
  };
  protoOf(AbstractJsonLexer).n5e = function (key) {
    var processed = this.q5h(0, this.b58_1);
    var lastIndexOf_0 = lastIndexOf(processed, key);
    this.o5h("Encountered an unknown key '" + key + "'", lastIndexOf_0, "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.");
  };
  protoOf(AbstractJsonLexer).o5h = function (message, position, hint) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(hint) === 0) {
      tmp = '';
    } else {
      tmp = '\n' + hint;
    }
    var hintMessage = tmp;
    throw JsonDecodingException_0(position, message + ' at path: ' + this.c58_1.h5c() + hintMessage, this.i5h());
  };
  protoOf(AbstractJsonLexer).u5b = function (message, position, hint, $super) {
    position = position === VOID ? this.b58_1 : position;
    hint = hint === VOID ? '' : hint;
    return $super === VOID ? this.o5h(message, position, hint) : $super.o5h.call(this, message, position, hint);
  };
  protoOf(AbstractJsonLexer).z5e = function () {
    var current = this.p5h();
    current = this.j5h(current);
    if (current >= charSequenceLength(this.i5h()) || current === -1) {
      this.u5b('EOF');
    }
    var tmp;
    if (charSequenceGet(this.i5h(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      if (current === charSequenceLength(this.i5h())) {
        this.u5b('EOF');
      }
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var accumulator = new Long(0, 0);
    var isNegative = false;
    var start = current;
    var hasChars = true;
    $l$loop_0: while (hasChars) {
      var ch = charSequenceGet(this.i5h(), current);
      if (ch === _Char___init__impl__6a9atx(45)) {
        if (!(current === start)) {
          this.u5b("Unexpected symbol '-' in numeric literal");
        }
        isNegative = true;
        current = current + 1 | 0;
        continue $l$loop_0;
      }
      var token = charToTokenClass(ch);
      if (!(token === 0))
        break $l$loop_0;
      current = current + 1 | 0;
      hasChars = !(current === charSequenceLength(this.i5h()));
      var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
      if (!(0 <= digit ? digit <= 9 : false)) {
        this.u5b("Unexpected symbol '" + toString_1(ch) + "' in numeric literal");
      }
      // Inline function 'kotlin.Long.minus' call
      // Inline function 'kotlin.Long.times' call
      accumulator = accumulator.n2(toLong_0(10)).m2(toLong_0(digit));
      if (accumulator.a1(new Long(0, 0)) > 0) {
        this.u5b('Numeric value overflow');
      }
    }
    if (start === current || (isNegative && start === (current - 1 | 0))) {
      this.u5b('Expected numeric literal');
    }
    if (hasQuotation) {
      if (!hasChars) {
        this.u5b('EOF');
      }
      if (!(charSequenceGet(this.i5h(), current) === _Char___init__impl__6a9atx(34))) {
        this.u5b('Expected closing quotation mark');
      }
      current = current + 1 | 0;
    }
    this.b58_1 = current;
    var tmp_0;
    if (isNegative) {
      tmp_0 = accumulator;
    } else if (!accumulator.equals(new Long(0, -2147483648))) {
      tmp_0 = accumulator.s2();
    } else {
      this.u5b('Numeric value overflow');
    }
    return tmp_0;
  };
  protoOf(AbstractJsonLexer).x5e = function () {
    return consumeBoolean2(this, this.p5h());
  };
  protoOf(AbstractJsonLexer).y5e = function () {
    var current = this.p5h();
    if (current === charSequenceLength(this.i5h())) {
      this.u5b('EOF');
    }
    var tmp;
    if (charSequenceGet(this.i5h(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var result = consumeBoolean2(this, current);
    if (hasQuotation) {
      if (this.b58_1 === charSequenceLength(this.i5h())) {
        this.u5b('EOF');
      }
      if (!(charSequenceGet(this.i5h(), this.b58_1) === _Char___init__impl__6a9atx(34))) {
        this.u5b('Expected closing quotation mark');
      }
      this.b58_1 = this.b58_1 + 1 | 0;
    }
    return result;
  };
  function charToTokenClass(c) {
    var tmp;
    // Inline function 'kotlin.code' call
    if (Char__toInt_impl_vasixd(c) < 126) {
      var tmp_0 = CharMappings_getInstance().s5h_1;
      // Inline function 'kotlin.code' call
      tmp = tmp_0[Char__toInt_impl_vasixd(c)];
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function escapeToChar(c) {
    return c < 117 ? CharMappings_getInstance().r5h_1[c] : _Char___init__impl__6a9atx(0);
  }
  function initEscape($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2ESC($this, i, _Char___init__impl__6a9atx(117));
      }
       while (inductionVariable <= 31);
    initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
    initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
    initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
    initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
    initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
    initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
    initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
    initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
  }
  function initCharToToken($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2TC($this, i, 127);
      }
       while (inductionVariable <= 32);
    initC2TC($this, 9, 3);
    initC2TC($this, 10, 3);
    initC2TC($this, 13, 3);
    initC2TC($this, 32, 3);
    initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
    initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
    initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
    initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
    initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
    initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
    initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
    initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
  }
  function initC2ESC($this, c, esc) {
    if (!(esc === _Char___init__impl__6a9atx(117))) {
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
      $this.r5h_1[tmp$ret$0] = numberToChar(c);
    }
  }
  function initC2ESC_0($this, c, esc) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2ESC($this, tmp$ret$0, esc);
  }
  function initC2TC($this, c, cl) {
    $this.s5h_1[c] = cl;
  }
  function initC2TC_0($this, c, cl) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2TC($this, tmp$ret$0, cl);
  }
  function CharMappings() {
    CharMappings_instance = this;
    this.r5h_1 = charArray(117);
    this.s5h_1 = new Int8Array(126);
    initEscape(this);
    initCharToToken(this);
  }
  var CharMappings_instance;
  function CharMappings_getInstance() {
    if (CharMappings_instance == null)
      new CharMappings();
    return CharMappings_instance;
  }
  function StringJsonLexer(source) {
    AbstractJsonLexer.call(this);
    this.x5h_1 = source;
  }
  protoOf(StringJsonLexer).i5h = function () {
    return this.x5h_1;
  };
  protoOf(StringJsonLexer).j5h = function (position) {
    return position < this.x5h_1.length ? position : -1;
  };
  protoOf(StringJsonLexer).z5c = function () {
    var source = this.x5h_1;
    $l$loop: while (!(this.b58_1 === -1) && this.b58_1 < source.length) {
      var tmp1 = this.b58_1;
      this.b58_1 = tmp1 + 1 | 0;
      var ch = charSequenceGet(source, tmp1);
      var tc = charToTokenClass(ch);
      var tmp;
      if (tc === 3) {
        continue $l$loop;
      } else {
        tmp = tc;
      }
      return tmp;
    }
    return 10;
  };
  protoOf(StringJsonLexer).k5e = function () {
    var current = this.p5h();
    if (current === this.x5h_1.length || current === -1)
      return false;
    if (charSequenceGet(this.x5h_1, current) === _Char___init__impl__6a9atx(44)) {
      this.b58_1 = this.b58_1 + 1 | 0;
      return true;
    }
    return false;
  };
  protoOf(StringJsonLexer).v5c = function () {
    var current = this.b58_1;
    if (current === -1)
      return false;
    $l$loop: while (current < this.x5h_1.length) {
      var c = charSequenceGet(this.x5h_1, current);
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop;
      }
      this.b58_1 = current;
      return this.l5h(c);
    }
    this.b58_1 = current;
    return false;
  };
  protoOf(StringJsonLexer).p5h = function () {
    var current = this.b58_1;
    if (current === -1)
      return current;
    $l$loop: while (current < this.x5h_1.length) {
      var c = charSequenceGet(this.x5h_1, current);
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
      } else {
        break $l$loop;
      }
    }
    this.b58_1 = current;
    return current;
  };
  protoOf(StringJsonLexer).j5e = function (expected) {
    if (this.b58_1 === -1) {
      this.n5h(expected);
    }
    var source = this.x5h_1;
    $l$loop: while (this.b58_1 < source.length) {
      var tmp1 = this.b58_1;
      this.b58_1 = tmp1 + 1 | 0;
      var c = charSequenceGet(source, tmp1);
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      if (c === expected)
        return Unit_instance;
      this.n5h(expected);
    }
    this.n5h(expected);
  };
  protoOf(StringJsonLexer).p5e = function () {
    this.j5e(_Char___init__impl__6a9atx(34));
    var current = this.b58_1;
    var closingQuote = indexOf(this.x5h_1, _Char___init__impl__6a9atx(34), current);
    if (closingQuote === -1) {
      this.m5h(1);
    }
    var inductionVariable = current;
    if (inductionVariable < closingQuote)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charSequenceGet(this.x5h_1, i) === _Char___init__impl__6a9atx(92)) {
          return this.consumeString2(this.x5h_1, this.b58_1, i);
        }
      }
       while (inductionVariable < closingQuote);
    this.b58_1 = closingQuote + 1 | 0;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.x5h_1.substring(current, closingQuote);
  };
  protoOf(StringJsonLexer).r5e = function (keyToMatch, isLenient) {
    var positionSnapshot = this.b58_1;
    try {
      if (!(this.z5c() === 6))
        return null;
      var firstKey = isLenient ? this.p5e() : this.q5e();
      if (firstKey === keyToMatch) {
        if (!(this.z5c() === 5))
          return null;
        var result = isLenient ? this.w5c() : this.q5e();
        return result;
      }
      return null;
    }finally {
      this.b58_1 = positionSnapshot;
    }
  };
  function get_schemaCache(_this__u8e3s4) {
    return _this__u8e3s4.r57_1;
  }
  function JsonToStringWriter() {
    this.s57_1 = StringBuilder_init_$Create$_0(128);
  }
  protoOf(JsonToStringWriter).z5a = function (value) {
    this.s57_1.n7(value);
  };
  protoOf(JsonToStringWriter).t5a = function (char) {
    this.s57_1.p7(char);
  };
  protoOf(JsonToStringWriter).v5a = function (text) {
    this.s57_1.o7(text);
  };
  protoOf(JsonToStringWriter).f5b = function (text) {
    printQuoted(this.s57_1, text);
  };
  protoOf(JsonToStringWriter).a2p = function () {
    this.s57_1.gb();
  };
  protoOf(JsonToStringWriter).toString = function () {
    return this.s57_1.toString();
  };
  function createMapForCache(initialCapacity) {
    return HashMap_init_$Create$(initialCapacity);
  }
  //region block: post-declaration
  protoOf(defer$1).w1e = get_isNullable;
  protoOf(defer$1).d1f = get_isInline;
  protoOf(defer$1).b1f = get_annotations;
  protoOf(PolymorphismValidator).m1x = contextual;
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  Tombstone_instance = new Tombstone();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Json_0;
  _.$_$.b = Json;
  //endregion
  return _;
}));
